/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Row, Col, Accordion, Card, Button, FormGroup, Table, Container, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import { isEmpty, uniqBy, cloneDeep, isArray, uniq, set, concat } from 'lodash';
import noImage from '../../../assets/images/no-image.png';
import { commonPath, ADDITIONAL_INFO_MAX_LENGTH } from '../../DevlopmentOrder/Bom/BomProvider/filedPaths';
import SupportingDocumentTable from '../../../Components/SupportingDocument/SupportingDocumentTable';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import * as colourAction from '../ColorLibary/store/ColorLibrary.action';
import * as action from './store/BomLibrary.action';
import * as supplierAction from '../../Supplier/store/Supplier.action';
import * as supportingAction from '../../../Components/SupportingDocument/store/SupportingDocument.action';
import * as masterAction from '../../SystemMasters/Store/SystemMasters.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import DeletePopup from '../../../Components/ModalPopup/DeletePopup';
import SetComponentType from '../../../Components/SetComponentType/SetComponentType';
import SearchBar from '../../../Components/Utility/FilterAction/SearchBar';
import {
  checkArray,
  compareObjectWithKey,
  customStyles,
  transportArray,
  pickKeys,
  convertDottedToObject,
  convertSelectLabel,
  currencyCodes,
} from '../../../Components/helper';
import BomColourwaysComponent from './BomColourwaysComponent';
import BomSubType from './bomSubType';
import './bomlibrary.css';
import ImageUploadModal from '../../../Components/ModalPopup/ImageUploadModal';
import BomProductImpact from './BomProductImpact';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import { getBomDetailsBasedOnId, clearBomEditModalData } from '../../DevlopmentOrder/store/DevelopmentOrder.action';
import CustomToggle from '../../../Components/CustomToggle';
import { getImagesByLocation, IMAGE_PICKER_EXTENSIONS } from '../../AssetLibrary/Assets/store/asset.service';
import { abortUpload } from '../../../utils/active-uploads-registry';
import '../Library.css';
import BomImageDropzone from '../../../Components/ImgDropzone/BomImageDropzone';


function AddEditBomLibrary({
  title,
  toggle,
  id,
  BOMProperty,
  addBomLibaray,
  BOMId,
  EditBomLibaray,
  itemList,
  isImport,
  devOrderId,
  libId,
  isFromLibrary,
  setIsAddEditClick,
  dppAddEditAccess,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const reducerState = useSelector((redState) => redState);
  const { UserDetails, BomLibraryDetails, SuppliersDetails, SystemMastersDetails, BOMConfigDetails, Measuremets } = reducerState;
  const { userInfo } = UserDetails;
  const {
    finalList,
    brandList,
    category1List,
    category2List,
    category3List,
    category4List,
    placement_master,
    customAttributeBomList,
    subBrandAccess,
    subBrandList,
    pcTypeList,
  } = SystemMastersDetails;
  const { ReferenceType, Composition, UnitOfMeasure, colourDocs, bomComponentSubTypeList } = BomLibraryDetails;
  const activeReferenceType = useMemo(() => ReferenceType?.filter((option) => option?.isActive) ?? [], [ReferenceType]);
  const { suppliers } = BOMConfigDetails;
  const { tier2Suppliers, tier1Suppliers } = SuppliersDetails;
  const { bomDetailsBasedOnId } = Measuremets;
  const loggedInUserId = userInfo.userId;

  const {
    register,
    watch,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const bomColourRef = useRef();
  const bomProductImpact = useRef();
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);
  const [selectedProductType, setSelectedProductType] = useState(null);

  const inputReferenceCode = watch('referenceCode');
  const inputBomDescription = watch('bomDescription');
  const inputSize = watch('size');
  const inputWeight = watch('weight');
  const inputQuantity = watch('quantity');
  const inputadditionalInfo = watch('additionalInfo');
  const highlightedFieldCustomReactSelect = 'highlighted-field add-common-form custom-react-select';
  const highlightedField = 'highlighted-field add-common-form';
  const customReactSelect = 'custom-react-select add-common-form';
  const highlightedFieldClass = 'highlighted-field add-common-form d-flex';

  const [searchText, setSearchText] = useState('');
  const [count, setCount] = useState(false);
  const [filteredPermit, setFilteredPermit] = useState([]);
  const [finalDocuments, setFinalDocuments] = useState([]);
  const [isSubBOMSwitch, setSubBOMSwitch] = useState(false);
  const [showPercentageError, setShowPercentageError] = useState(false);
  const [showPercentageValueError, setShowPercentageValueError] = useState(false);
  const [error, setShowError] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [sendDocument, setSendDocument] = useState(false);
  const [bomDescriptionCount, setBomDescriptionCount] = useState(0);
  const [showRequirmentError, setShowRequirmentError] = useState(false);
  const [editState, setEditState] = useState({
    mode: false,
    data: null,
  });
  const bomSavedRef = useRef(false);
  const abortOnBackRef = useRef({ devOrderId: null, isCreate: true, queueFiles: {} });
  abortOnBackRef.current = {
    devOrderId: devOrderId || null,
    isCreate: !editState.mode,
    queueFiles: reducerState?.uploader?.queueFiles || {},
  };

  useEffect(() => {
    return () => {
      const { devOrderId: currentDevOrderId, isCreate, queueFiles } = abortOnBackRef.current;
      if (bomSavedRef.current || !isCreate) {
        return;
      }
      Object.values(queueFiles)
        .filter((task) => task?.module === 'bom-supporting-doc' && !task?.completed && (task?.devOrderId || null) === currentDevOrderId)
        .forEach((task) => task?.taskId && abortUpload(task.taskId));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [ImageState, setImageState] = useState({
    mode: false,
    data: null,
  });
  const [compositionErrors, setCompositionErrors] = useState([
    {
      percentage: '',
      composition: '',
    },
  ]);
  const [bomDeletedData, setBomDeletedData] = useState([]);
  const [bomDocumentState, setBomDocumentState] = useState({
    cardList: [
      {
        isSave: false,
        error: false,
        isDefault: true,
        composition: [
          {
            percentage: null,
            composition: null,
          },
        ],
      },
    ],
    loading: false,
  });
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [inSubmit, setInSubmit] = useState(false);
  const [emptyDocs, setEmptyDocs] = useState(false);
  const [croppedImage, setCroppedImage] = useState(noImage);
  const [prevcroppedImage, setPrevCroppedImage] = useState('');
  const [removeLibId, setRemoveLibId] = useState('');
  const [eventId, setEventId] = useState(-1);
  const [upSupplier, setUpSupplier] = useState([]);
  const [bomSubType, setBomSubType] = useState(null);
  const [bomComponentSubType, setBomComponentSubType] = useState(null);
  const [transport, setTransport] = useState(null);
  const [quality, setQuality] = useState(null);
  const [brand, setBrand] = useState(null);
  const [category1, setCategory1] = useState(null);
  const [category2, setCategory2] = useState(null);
  const [category3, setCategory3] = useState(null);
  const [category4, setCategory4] = useState(null);
  const [sizeUnitOfMeasure, setSizeUnitOfMeasure] = useState(null);
  const [weightUnitOfMeasure, setweightUnitOfMeasure] = useState(null);
  const [quantityUnitOfMeasure, setQuantityUnitOfMeasure] = useState(null);
  const [final, setFinal] = useState(null);
  const [placementValue, setPlacementValue] = useState([]);
  const [multipleSuppliers, selectMultipleSuppliers] = useState([]);
  const [BomSuppliers, selectBomSuppliers] = useState([]);
  const [customBom, setCustomBom] = useState({
    composition: [
      {
        percentage: null,
        composition: null,
      },
    ],
  });
  const [columnHeader, setCoumnHeader] = useState(['BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION']);
  const lastIndex = customBom.composition.length - 1;
  const [colorDocumentId, setColorDocumentId] = useState([]);
  const [showImageRemoveConfirmationPopup, setShowImageRemoveConfirmationPopup] = useState(false);
  const [removeImage, setRemoveImage] = useState(false);
  const [colorWay, setColorWay] = useState({
    list: [
      {
        colourWayId: null,
        componentSupplier: null,
        supplierList: [],
        tier1Supplier: null,
        suppilerName: '',
        componentSupplierName: '',
        colourWayName: '',
        colourWayRefName: '',
        colourRefsDataAsPerSuppliers: [
          {
            colourRef: null,
            colourRefNumber: '',
            supplier: null,
            comment: '',
            commentDate: null,
            approveBy: null,
            tier1Supplier: null,
            componentSupplier: null,
            colourRefName: null,
            colourPlacement: null,
          },
        ],
      },
    ],
  });

  const [combinedDataArray, setCombinedDataArray] = useState([{ componentSupplier: null, productSupplier: null }]);
  const [showNewTable, setShowNewTable] = useState(false);
  const [showCombinationArray, setShowCombinationArray] = useState(false);
  const [showRemoveCombinationArray, setShowRemoveCombinationArray] = useState(false);
  const [renderSuppotingDoc, setRenderSuppotingDoc] = useState(false);
  const [isNewUploaded, setIsNewUploaded] = useState(true);
  const [originalImage, setOriginalImage] = useState(null);
  const [selectedAssetKey, setSelectedAssetKey] = useState(null);
  const [selectedAssetId, setSelectedAssetId] = useState(null);
  const [isUploadAsset, setIsUploadAsset] = useState(false);
  /**
   * Whether the user ticked "Add to Asset Library" alongside a device upload. Sent to the save as
   * `isAddToAssetLibrary`, which stores the image under the Asset Library prefix instead of the
   * BOM's own. Never set for a library pick, which is already an asset.
   */
  const [sendToAssetLibrary, setSendToAssetLibrary] = useState(false);
  const [imageSize, setImageSize] = useState('');
  const [imageType, setImageType] = useState('');
  const [imageName, setImageName] = useState('');
  const [refCode, setRefCode] = useState('');
  const [showSubTypeLoader, setShowSubTypeLoader] = useState(false);
  const [showComponentTypePopup, setShowComponentTypePopup] = useState(false);
  const [showComponentSubTypePopup, setShowComponentSubTypePopup] = useState(false);
  const [state, setState] = useState({
    clonedBomData: null,
    highlightedKeys: [],
    bomApiLoder: false,
  });
  const { clonedBomData, highlightedKeys, bomApiLoder } = state;
  const [activeKey, setActiveKey] = useState(null);
  const [subBomActiveKey, setSubBomActiveKey] = useState(null);
  const [oldDocIds, setOldDocIds] = useState([]);
  const [showCompositionModal, setShowCompositionModal] = useState(false);
  const [pricePerUnitCurrency, setPricePerUnitCurrency] = useState(null);

  const [placementOptions, setPlacementOptions] = useState([]);
  const [subBrand, setSubBrand] = useState(null);
  const [subBrandOption, setSubBrandOption] = useState([]);

  const category1Derived = useMemo(() => {
    if (!catBasedOnPTData) return category1List || [];
    const ptId = selectedProductType?._id;
    if (!ptId) return [];
    return (category1List || []).filter((c1) => {
      const pts = c1?.productType || [];
      const arr = Array.isArray(pts) ? pts : [pts];
      const ids = arr.map((x) => x?._id || x).filter(Boolean);
      return ids?.includes(ptId);
    });
  }, [catBasedOnPTData, selectedProductType?._id, category1List]);

  const category2Derived = useMemo(() => {
    if (!catBasedOnPTData) return category2List || [];
    if (!category1?._id) return [];
    return (category2List || []).filter((c2) => {
      const rel = c2?.categoryOneId || c2?.catOneIds || [];
      const arr = Array.isArray(rel) ? rel : [rel];
      const ids = arr.map((x) => x?._id || x).filter(Boolean);
      return ids?.includes(category1?._id);
    });
  }, [catBasedOnPTData, category1?._id, category2List]);

  const category3Derived = useMemo(() => {
    if (!catBasedOnPTData) return category3List || [];
    if (!category1?._id || !category2?._id) return [];
    return (category3List || []).filter((c3) => {
      const r1 = c3?.categoryOneId || c3?.catOneIds || [];
      const r2 = c3?.categoryTwoId || c3?.catTwoIds || [];
      const a1 = (Array.isArray(r1) ? r1 : [r1]).map((x) => x?._id || x).filter(Boolean);
      const a2 = (Array.isArray(r2) ? r2 : [r2]).map((x) => x?._id || x).filter(Boolean);
      return a1?.includes(category1?._id) && a2?.includes(category2?._id);
    });
  }, [catBasedOnPTData, category1?._id, category2?._id, category3List]);

  const category4Derived = useMemo(() => {
    if (!catBasedOnPTData) return category4List || [];
    if (!category1?._id || !category2?._id || !category3?._id) return [];
    return (category4List || []).filter((c4) => {
      const r1 = c4?.categoryOneId || c4?.catOneIds || [];
      const r2 = c4?.categoryTwoId || c4?.catTwoIds || [];
      const r3 = c4?.categoryThreeId || c4?.catThreeIds || [];
      const a1 = (Array.isArray(r1) ? r1 : [r1]).map((x) => x?._id || x).filter(Boolean);
      const a2 = (Array.isArray(r2) ? r2 : [r2]).map((x) => x?._id || x).filter(Boolean);
      const a3 = (Array.isArray(r3) ? r3 : [r3]).map((x) => x?._id || x).filter(Boolean);
      return a1?.includes(category1?._id) && a2?.includes(category2?._id) && a3?.includes(category3?._id);
    });
  }, [catBasedOnPTData, category1?._id, category2?._id, category3?._id, category4List]);

  useEffect(() => {
    try {
      dispatch(
        masterAction.getPCTypesDetails({
          loggedInUserId: userInfo?.userId,
          isActive: true,
          tier: 'Tier1',
        }),
      );
    } catch (e) {}
  }, [dispatch, userInfo?.userId]);

  useEffect(() => {
    const fetchFlag = async () => {
      try {
        const res = await dispatch(masterAction.getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchFlag();
  }, [dispatch]);

  useEffect(() => {
    if (brand) {
      const queryParams = {
        brandId: brand?._id,
        loggedInUserId,
      };
      dispatch(masterAction.getSubBrandDetails(queryParams));
    }
  }, [brand]);

  useEffect(() => {
    if (subBrandList) {
      setSubBrandOption(subBrandList);
    }
  }, [subBrandList]);

  const getCustomBomAttributeList = async () => {
    await dispatch(masterAction.getBomCustomAttribute());
  };

  const referenceOptions =
    id &&
    bomDocumentState?.cardList?.map((item) => ({
      name: item.referenceCode || '',
      _id: item._id || '',
    }));

  useEffect(() => {
    if (placement_master?.length > 0) {
      const placementData = placement_master?.map((item) => ({
        label: item.name,
        value: item._id,
      }));
      setPlacementOptions(placementData);
    }
  }, [placement_master]);

  useEffect(() => {
    const callFn = async () => {
      if (devOrderId && id && BOMId && !isFromLibrary) {
        setState((prev) => ({ ...prev, bomApiLoder: true }));
        const res = await dispatch(getBomDetailsBasedOnId(devOrderId, id, BOMId));
        if (res) {
          setState((prev) => ({ ...prev, bomApiLoder: false }));
        }
      }
    };
    callFn();
  }, [id, devOrderId, dispatch, BOMId, isFromLibrary]);

  useEffect(() => {
    setTimeout(() => {
      if (!isFromLibrary) {
        setCount(true);
      }
    }, 2000);
  }, []);

  const addUpdateHighlightedKey = (isSame, keyField) => {
    if (!isSame) {
      if (!highlightedKeys?.includes(keyField)) {
        setState((prevState) => ({
          ...prevState,
          highlightedKeys: [...highlightedKeys, keyField],
        }));
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        highlightedKeys: highlightedKeys?.filter((eleKey) => eleKey !== keyField),
      }));
    }
  };

  useEffect(() => {
    if (clonedBomData && id && count) {
      const oldObj = clonedBomData.referenceCode;
      const newObj = inputReferenceCode;
      const isSameValue = oldObj === newObj;
      addUpdateHighlightedKey(isSameValue, 'referenceCode');
    }
  }, [inputReferenceCode]);

  useEffect(() => {
    if (clonedBomData && id && count) {
      const oldObj = clonedBomData.bomDescription;
      const newObj = inputBomDescription;
      const isSameValue = oldObj === newObj;

      addUpdateHighlightedKey(isSameValue, 'bomDescription');
    }
  }, [inputBomDescription]);

  useEffect(() => {
    if (clonedBomData && id && count) {
      const oldObj = clonedBomData.size;
      const newObj = inputSize;
      const isSameValue = oldObj === newObj;
      addUpdateHighlightedKey(isSameValue, 'size');
    }
  }, [inputSize]);

  useEffect(() => {
    if (clonedBomData && id && count) {
      const oldObj = clonedBomData.weight;
      const newObj = inputWeight;
      const isSameValue = oldObj === newObj;
      addUpdateHighlightedKey(isSameValue, 'weight');
    }
  }, [inputWeight]);

  useEffect(() => {
    if (clonedBomData && id && count) {
      const oldObj = clonedBomData.quantity;
      const newObj = inputQuantity;
      const isSameValue = oldObj === newObj;
      addUpdateHighlightedKey(isSameValue, 'quantity');
    }
  }, [inputQuantity]);

  useEffect(() => {
    if (clonedBomData && id && count) {
      const oldObj = clonedBomData.additionalInfo;
      const newObj = inputadditionalInfo;
      const isSameValue = oldObj === newObj;
      addUpdateHighlightedKey(isSameValue, 'additionalInfo');
    }
  }, [inputadditionalInfo]);

  useEffect(() => {
    if (inputBomDescription) {
      setBomDescriptionCount(inputBomDescription.length);
    }
  }, [inputBomDescription]);

  const getBOMSupplier = () => {
    const ids = [];
    if (!isEmpty(BomSuppliers)) {
      BomSuppliers.forEach((ele) => {
        ids.push(ele._id);
      });
    }
    return ids;
  };

  const forIfs = (ele) => {
    return (ele?.percentage && !ele?.composition) || ((!ele?.percentage || ele.percentage === '') && ele?.composition);
  };

  const uniqDocIds = () => {
    const idsArray = cloneDeep([...finalDocuments]);
    idsArray.forEach((ele, i) => {
      idsArray.forEach((element, index) => {
        if (i !== index && ele === element) {
          idsArray.splice(i, 1);
        }
      });
    });
    return uniq(idsArray?.map((e) => (typeof e === 'object' ? e?._id : e)));
  };

  const compositionCalled = () => {
    let compositionArray = [];
    if (customBom && !isEmpty(customBom?.composition)) {
      let hasEmptyPair = false;
      customBom.composition.forEach((ele) => {
        if (forIfs(ele)) {
          setShowPercentageError(true);
        } else if (customBom?.composition?.length > 1 && (customBom.composition?.[0].percentage !== null || customBom.composition?.[0].composition !== null)) {
          compositionArray = customBom?.composition.map((item) => ({
            ...item,
            composition: item?.composition?._id ? item?.composition?._id : null,
          }));
          hasEmptyPair = compositionArray.some((item) => !item?.composition || !item?.percentage);
          if (hasEmptyPair) {
            setShowError(true);
          }
        } else {
          compositionArray = customBom?.composition
            .map((item) => ({
              ...item,
              composition: item?.composition?._id ? item?.composition?._id : null,
            }))
            .filter((item) => item?.composition && item?.percentage);
        }
      });
    }
    return compositionArray;
  };

  const forObjectValue = (data, colorObj) => {
    return {
      ...data,
      bomType: BOMProperty?._id ? BOMProperty._id : '',
      suppliers: multipleSuppliers?.length > 0 ? multipleSuppliers?.filter((item) => item?.value).map((item) => item.value) : [],
      weightUnitOfMeasure: weightUnitOfMeasure?._id ? weightUnitOfMeasure._id : null,
      bomSubType: bomSubType?._id ? bomSubType._id : null,
      BOMSupplier: getBOMSupplier(),
      quantityUnitOfMeasure: quantityUnitOfMeasure?._id ? quantityUnitOfMeasure._id : null,
      sizeUnitOfMeasure: sizeUnitOfMeasure?._id ? sizeUnitOfMeasure._id : null,
      composition: compositionCalled(),
      removeImage,
      fullImage: isUploadAsset && selectedAssetKey ? selectedAssetKey : originalImage,
      colourWayRefsData: colorObj || [],
      docIds: uniqDocIds(),
      combinationSuppliers: combinedArrayIds(),
      bomComponentSubType: bomComponentSubType?._id ? bomComponentSubType._id : null,
      transport: transport || null,
      quality: quality || null,
      dynamicColumn: clonedBomData?.dynamicColumn?.map((childEle) => ({
        colId: childEle?._id || childEle?.colId?._id,
        valueId: childEle?.optionsValue?._id ? { _id: childEle?.optionsValue?._id, keyName: childEle?.optionsValue?.keyName } : childEle?.valueId,
        valueText: childEle?.valueText ? childEle?.valueText : '',
      })),
      pricePerUnitCurrency: pricePerUnitCurrency?.value ? pricePerUnitCurrency.value : null,
      isUploadAsset,
      assetId: isUploadAsset ? selectedAssetId || null : null,
      isAddToAssetLibrary: sendToAssetLibrary && !isUploadAsset,
      devOrderId: devOrderId || null,
    };
  };
  const combinedArrayIds = () => {
    const array = [];
    combinedDataArray?.[0]?.componentSupplier !== null &&
      combinedDataArray?.[0]?.productSupplier !== null &&
      combinedDataArray.forEach((arrEle) => {
        array.push({
          productSupplier: arrEle?.productSupplier?._id,
          componentSupplier: arrEle?.componentSupplier?._id,
        });
      });
    return array;
  };

  const forCroppedImage = (obj) => {
    if (croppedImage !== noImage) {
      const imageValue = isUploadAsset && selectedAssetKey ? selectedAssetKey : croppedImage;
      obj.image = imageValue === prevcroppedImage ? 'DoNotChange' : imageValue;
    } else {
      obj.image = '';
    }
  };

  const forEditStateData = (obj) => {
    if (editState.data) {
      if (isImport) {
        obj.libId = editState?.data?.libId ? editState?.data?.libId : '';
      }
      obj._id = editState?.data?._id ? editState?.data?._id : '';
    }
  };

  const forOnSubmit = (data) => {
    if (data !== null) {
      const keys = Object.keys(data);
      for (const item of keys) {
        if (item?.includes('colourdata')) {
          delete data[item];
        }
      }
    }
  };

  const forSecondIf = (colorObj) => {
    for (let i = 0; i < colorWay.list.length; i++) {
      if (!isEmpty(colorWay.list[i].colourWayId) && !isEmpty(colorWay.list[i].colourRefsDataAsPerSuppliers)) {
        const data = colorWay.list[i];
        forSupplierCalled(i, data);
        colorObj.push(data);
      }
    }
  };

  const forSupplierCalled = (i, data) => {
    if (colorWay.list[i].colourRefsDataAsPerSuppliers) {
      const array = colorWay.list[i].colourRefsDataAsPerSuppliers.map((ele) => {
        let stic = {};
        if (ele.colourRef) {
          stic = {
            ...ele,
            autoApprove: ele.autoApprove,
            colourRef: ele.colourRef,
          };
        } else {
          stic = null;
        }
        return stic;
      });
      data.colourRefsDataAsPerSuppliers = array && array.length > 0 ? array.filter((item) => item) : [];
    }
  };

  function groupAndMerge(data) {
    const resultMap = new Map();
    data?.forEach((doc) => {
      const colourWayId = doc?.colourWayId?._id;
      const existingDoc = resultMap?.get(colourWayId);
      if (existingDoc) {
        existingDoc.colourRefsDataAsPerSuppliers = existingDoc.colourRefsDataAsPerSuppliers || [];
        if (doc?.colourRefsDataAsPerSuppliers) {
          existingDoc.colourRefsDataAsPerSuppliers.push(...doc.colourRefsDataAsPerSuppliers);
        }
      } else {
        resultMap?.set(colourWayId, { ...doc });
      }
    });

    return [...resultMap.values()];
  }

  const formatColourWayRefsData = (colourRefArry) => {
    const manipulatedArray = [];

    const colourewausRefData = isFromLibrary ? colourRefArry : groupAndMerge(colourRefArry);
    if (isArray(colourewausRefData) && colourewausRefData.length > 0) {
      colourewausRefData.forEach((colur) => {
        if (colur?.colourWayId || isFromLibrary) {
          if (isArray(colur?.colourRefsDataAsPerSuppliers) && colur?.colourRefsDataAsPerSuppliers.length > 0) {
            const newManipulateColourRefAsSupplier = [];
            colur?.colourRefsDataAsPerSuppliers?.forEach((colourSupp) => {
              let statusValue = null;
              let approveBy = null;
              if (colourSupp?.status === 'Approved') {
                statusValue = 1;
                approveBy = loggedInUserId;
              } else if (colourSupp?.status === 'Rejected') {
                statusValue = 0;
                approveBy = loggedInUserId;
              }

              const objs = {
                ...colourSupp,
                colourRef: typeof colourSupp?.colourRef === 'object' ? colourSupp?.colourRef?._id : colourSupp?.colourRef,
                tier1Supplier: typeof colourSupp?.tier1Supplier === 'object' ? colourSupp?.tier1Supplier?._id : colourSupp?.tier1Supplier,
                componentSupplier: typeof colourSupp?.componentSupplier === 'object' ? colourSupp?.componentSupplier?._id : colourSupp?.componentSupplier,
                colourRefName: typeof colourSupp?.colourRefName === 'object' ? colourSupp?.colourRefName?._id : colourSupp?.colourRefName,
                colourPlacement: typeof colourSupp?.colourPlacement === 'object' ? colourSupp?.colourPlacement?._id : colourSupp?.colourPlacement,
                approveBy,
                status: statusValue,
              };
              if (objs?.componentSuppliersOPtionsMemo) delete objs?.componentSuppliersOPtionsMemo;
              newManipulateColourRefAsSupplier.push(objs);
            });
            colur.colourRefsDataAsPerSuppliers = newManipulateColourRefAsSupplier;
          }
          colur.colourWayId = typeof colur?.colourWayId === 'object' ? colur?.colourWayId?._id : colur?.colourWayId;
          delete colur?.supplierList;
          manipulatedArray.push(colur);
        }
      });
    }
    return manipulatedArray;
  };

  const handleOpenAccordion = () => {
    setActiveKey(activeKey === '0' ? null : '0');
  };

  /**
   * Expand or collapse the Sub BOM panel.
   *
   * Sub BOM keeps its own key rather than sharing `activeKey` with the Multiple Suppliers panel.
   * Both panels are separate `Accordion`s whose single item is `eventKey="0"`, so one shared key
   * matches both at once and opening either one opens the other. `activeKey` stays with Multiple
   * Suppliers because `handleOpenAccordionOnError` reveals that panel when supplier validation
   * fails.
   */
  const handleOpenSubBomAccordion = () => {
    setSubBomActiveKey(subBomActiveKey === '0' ? null : '0');
  };

  const handleOpenAccordionOnError = () => {
    if (activeKey !== '0') {
      setActiveKey('0');
    }
  };

  const handleSelectProductType = (pt) => {
    setSelectedProductType(pt || null);
    if (catBasedOnPTData) {
      const ptId = pt?._id;
      const c1ok = (c1) => {
        const pts = c1?.productType || [];
        const arr = Array.isArray(pts) ? pts : [pts];
        const ids = arr.map((x) => x?._id || x).filter(Boolean);
        return ptId ? ids?.includes(ptId) : false;
      };
      if (category1 && !c1ok(category1)) {
        setValue('category1', null, { shouldValidate: false });
        setCategory1(null);
      }
      if (!pt) {
        setValue('category1', null, { shouldValidate: false });
        setValue('category2', null, { shouldValidate: false });
        setValue('category3', null, { shouldValidate: false });
        setValue('category4', null, { shouldValidate: false });
        setCategory1(null);
        setCategory2(null);
        setCategory3(null);
        setCategory4(null);
      }
      setCategory2(null);
      setCategory3(null);
      setCategory4(null);
    }
  };

  function isBomHasAnyValue(obj) {
    const excludedKeys = ['isSave', 'error', 'isDefault', 'id', 'loading', '_id'];
    for (const key in obj) {
      if (!excludedKeys.includes(key)) {
        const value = obj[key];
        if (Array.isArray(value)) {
          for (const item of value) {
            if (isBomHasAnyValue(item)) {
              return true;
            }
          }
        } else if (typeof value === 'object' && value !== null) {
          if (isBomHasAnyValue(value)) {
            return true;
          }
        } else if (value !== null && value !== undefined && value !== '') {
          return true;
        }
      }
    }
    return false;
  }

  const returnProductImpact = (productImpact) => {
    const keysToPick = [
      'tierOne',
      'tierTwo.postProcessingAnotherLocation',
      'tierTwo.finishedProductAssemblySupp',
      'tierTwo.componentSupplierObj.componentSupplier',
      'tierTwo.componentSupplierObj.transport',
      'tierTwo.componentSupplierObj.bomProcessType',
      'tierTwo.componentPostProcessing.postProcessingSupp',
      'tierTwo.componentPostProcessing.bomProcessType',
      'tierTwo.componentPostProcessing.transport',
      'tierThree.rawMaterialProcessorExtractor',
      'tierThree.rawMaterialProcessor',
      'tierThree.bomProcessType',
      'tierThree.transport',
      'tierFour.rawMaterialExtractor',
      'tierFour.transport',
      'tierFour.compositionProcessType',
    ];
    return pickKeys(productImpact, keysToPick);
  };

  const onSubmitMethod = async (data) => {
    const bomColourwayRefsArry = await bomColourRef?.current?.getState();
    const validateColourWays = await bomColourRef?.current?.validateColourways();
    const bomProductImpactStateData = await bomProductImpact?.current?.getBomImpactLocalState();

    if (!validateColourWays && !showPercentageValueError) {
      forOnSubmit(data);
      setInSubmit(true);
      if (eventId !== -1) {
        setEventId(-1);
      }
      const colorObj = [];
      if (colorWay?.list?.length > 0) {
        forSecondIf(colorObj);
      }
      const obj = forObjectValue(data, colorObj);
      if (catBasedOnPTData) {
        obj.productTypeId = selectedProductType?._id || null;
      }

      obj.productImpact = convertDottedToObject(returnProductImpact(bomProductImpactStateData));
      obj.addToDoc = sendDocument;
      if (sendDocument) {
        obj.imageSize = imageSize;
        obj.memeType = imageType;
        obj.imageName = imageName;
      }
      if (checkArray(highlightedKeys)) {
        obj.highlightedKeys = highlightedKeys;
      }
      forCroppedImage(obj);
      forEditStateData(obj);
      let isSucess = false;
      const percent = customBom.composition.map((ele) => ele.percentage === null);
      const comp = customBom.composition.map((ele) => ele.composition === null);
      if (
        ((customBom.composition?.[0].percentage !== null || customBom.composition?.[0].composition !== null) &&
          !percent.includes(true) &&
          !comp.includes(true)) ||
        (customBom.composition?.[0].percentage === null && customBom.composition?.[0].composition === null)
      ) {
        if ((showNewTable && !findIfCombinedDataNull()) || !showNewTable) {
          await setShowLoader(true);
          if (findIfCombinedDataUnique()) {
            toasterMsg(t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SUPLIER_UNIQUE'), 'danger');
            setShowLoader(false);
            handleOpenAccordionOnError();
          } else if (!checkBOMListData()) {
            toasterMsg(t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.PLEASE_FILL_REQUIRED_FIELD'), 'danger');
            setShowLoader(false);
          } else if (!validatePercentages()) {
            setShowLoader(false);
            return;
          } else if (isSameReferenceCode()) {
            toasterMsg(t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_CODE_UNIQUE'), 'danger');
            setShowLoader(false);
          } else if (editState.mode) {
            if (oldDocIds) {
              obj.oldDocIds = oldDocIds;
            }
            if (bomColourwayRefsArry) {
              obj.colourWayRefsData = formatColourWayRefsData(bomColourwayRefsArry?.colourWayRefsData);
            } else {
              obj.colourWayRefsData = [];
              obj.colorAutoApprove = false;
            }
            if (clonedBomData?.dynamicColumn) {
              const dynamicIds = customAttributeBomList.map((e) => e._id);

              clonedBomData.dynamicColumn = clonedBomData.dynamicColumn
                .filter((ele) => {
                  const id = ele?.colId?._id || ele?._id;
                  const matchingAttr = customAttributeBomList.find((attr) => attr._id === id);
                  return dynamicIds.includes(id) && matchingAttr?.isActive && !matchingAttr?.isDeleted && matchingAttr?.bomTypeID === BOMProperty?._id;
                })
                .map((ele) => {
                  const id = ele?.colId?._id || ele?._id;
                  const colDetails = ele?.colId || customAttributeBomList.find((attr) => attr._id === id);
                  const type = colDetails?.type;

                  const result = {
                    colId: colDetails,
                  };

                  if (type === 'text') {
                    result.valueText = ele.valueText || '';
                  } else if (type === 'Multi Dropdown') {
                    result.valueId = Array.isArray(ele.optionsValue)
                      ? ele.optionsValue.map((opt) => ({
                          _id: opt.value || opt._id,
                          keyName: opt.label || opt.keyName,
                        }))
                      : [];
                  } else {
                    result.valueId = ele.optionsValue
                      ? {
                          _id: ele.optionsValue.value || ele.optionsValue._id,
                          keyName: ele.optionsValue.label || ele.optionsValue.keyName,
                        }
                      : null;
                  }

                  return result;
                });
            }

            if (bomDocumentState?.cardList?.length > 0) {
              obj.subBomList = [...bomDocumentState.cardList, ...bomDeletedData];
            }
            obj.subBOMSwitch = isSubBOMSwitch;
            isSucess = await EditBomLibaray(obj, id, t);
          } else {
            if (bomColourwayRefsArry) {
              obj.colourWayRefsData = formatColourWayRefsData(bomColourwayRefsArry?.colourWayRefsData);
            } else {
              obj.colourWayRefsData = [];
              obj.colorAutoApprove = false;
            }
            if (bomDocumentState?.cardList?.length > 0) {
              obj.subBomList = [...bomDocumentState.cardList, ...bomDeletedData];
            }
            obj.subBOMSwitch = isSubBOMSwitch;
            isSucess = await addBomLibaray(obj, t);
          }
        } else {
          setShowLoader(false);
          setShowRequirmentError(true);
          handleOpenAccordionOnError();
        }
        if (isSucess) {
          bomSavedRef.current = true;
          setEmptyDocs(true);
          await Promise.all([dispatch(supportingAction.unmountSupportingDocuments()), dispatch(action.clearColourDocs())]);
          setShowLoader(false);
          setInSubmit(false);
          setShowRequirmentError(false);
          setFinalDocuments([]);
          toggle();
          setIsAddEditClick(false);
        } else {
          setShowLoader(false);
        }
      }
    }
  };

  const findIfCombinedDataNull = () => {
    let isNull = false;
    combinedDataArray.forEach((element) => {
      if (element.componentSupplier === null || element.productSupplier === null) {
        isNull = true;
      }
    });
    return isNull;
  };

  const findIfCombinedDataUnique = () => {
    const uniqArray = [];
    combinedDataArray.forEach((element) => {
      if (element.componentSupplier !== null || element.productSupplier !== null) {
        uniqArray.push(`${element?.componentSupplier?._id}_${element?.productSupplier?._id}`);
      }
    });
    return uniqArray.filter((item, index) => uniqArray.indexOf(item) !== index).length > 0;
  };

  const checkBOMListData = () => {
    let isValid = true;
    const copyState = cloneDeep(bomDocumentState?.cardList);
    bomDocumentState?.cardList.map((data, dataIndex) => {
      if ((!data?.referenceCode || !data.bomComponentType) && isBomHasAnyValue(data)) {
        const errorpath = commonPath(dataIndex, 'error').COMMON_PATH;
        set(copyState, errorpath, true);
        isValid = false;
      }
    });
    setBomDocumentState((previousState) => ({ ...previousState, cardList: copyState }));
    return isValid;
  };

  const isSameReferenceCode = () => {
    let isSameCode = false;
    const referenceCodes = new Set();

    bomDocumentState?.cardList?.forEach((data) => {
      if (referenceCodes.has(data.referenceCode)) {
        isSameCode = true;
      } else {
        referenceCodes.add(data.referenceCode);
      }
    });

    return isSameCode;
  };

  const validatePercentages = () => {
    let isValid = true;
    const copyState = cloneDeep(bomDocumentState?.cardList);
    const errors = [...compositionErrors];

    copyState.forEach((card, index) => {
      const totalPercentage = card.composition.reduce((sum, comp) => {
        return sum + (parseFloat(comp.percentage) || 0);
      }, 0);

      errors[index] = {};

      if (totalPercentage !== 100 && totalPercentage !== 0) {
        isValid = false;
        errors[index].percentage = `Error: ${totalPercentage}`;
      } else {
        errors[index].percentage = '';
      }

      card.composition.forEach((comp, compIndex) => {
        if (comp.percentage && !comp.composition) {
          isValid = false;
          errors[index].composition = t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION_PERCENTAGE_REQUIRED');
        } else {
          errors[index].composition = '';
        }
      });
    });

    setCompositionErrors(errors);
    return isValid;
  };

  const handleAddRow = (e) => {
    e.preventDefault();
    if (customBom.composition.length < 10) {
      setCustomBom((prev) => ({
        ...prev,
        composition: [
          ...customBom.composition,
          {
            percentage: null,
            composition: null,
          },
        ],
      }));
      setShowPercentageError(false);
    } else {
      alert(t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.NUMBER_ROWS'));
    }
  };

  const handleRemoveClick = (e, index) => {
    e.preventDefault();
    if (customBom.composition.length === 1) {
      return false;
    }
    const list = [...customBom.composition];
    list.splice(index, 1);
    setCustomBom({
      composition: list,
    });
    if (customBom.composition?.[0].percentage !== null) {
      validateTotalPercentage(list);
    }
  };
  const handleAddNewComposition = () => {
    setShowCompositionModal(true);
  };

  const validateTotalPercentage = (elements) => {
    const threshold = 0.001;

    const totalPercentage = elements.reduce((total, element) => {
      return total + (element.percentage ? parseFloat(element.percentage) : 0);
    }, 0);

    const isPercentageEqual = Math.abs(totalPercentage - 100) < threshold;

    if (!isPercentageEqual && totalPercentage) {
      setShowPercentageValueError(true);
    } else {
      setShowPercentageValueError(false);
    }
  };

  const handleChangeComposition = (event, index, field) => {
    if (event?._id === 'addNew') {
      handleAddNewComposition();
    } else {
      if (clonedBomData && id && count) {
        const oldObj = clonedBomData?.composition?.[index] ?? {};
        const newObj = event?.currentTarget?.value ?? event;
        let isSameValue = null;
        if (oldObj) {
          isSameValue = field === 'composition' ? oldObj[field]?.name === newObj?.name : oldObj[field] === newObj;
        }
        addUpdateHighlightedKey(isSameValue, 'composition');
      }
      const fieldName = event?.currentTarget?.name ? event.currentTarget.name : 'composition';
      const value = (event?.target?.value?.length > 0 ? event.target?.value : field === 'composition' && event) || null;
      const rows = [...customBom.composition];
      const clonedRowsIndex = cloneDeep(rows[index]);
      rows[index] = { ...clonedRowsIndex, [fieldName]: value || null };
      validateTotalPercentage(rows);
      setCustomBom({
        ...customBom,
        composition: rows,
      });
    }
  };

  useEffect(() => {
    if (!isEmpty(colourDocs)) {
      const c = colorDocumentId.find((o) => o._id === colourDocs?.[0]._id);
      if (!c) setColorDocumentId([...colorDocumentId, colourDocs?.[0]]);
    }
  }, [colourDocs]);

  useEffect(() => {
    if (!isEmpty(colorWay?.list)) {
      colorWay?.list.forEach((ele, i) => {
        if (!isEmpty(ele.colourWayId) && isEmpty(upSupplier)) {
          const rows = [...colorWay.list];
          rows[i].componentSupplier = null;
          const obj = {
            ...colorWay,
            list: rows,
          };
          setColorWay(obj);
        }
      });
    }
  }, [upSupplier]);

  /**
   * Called by ImageUploadModal when the user confirms their image selection.
   * Handles both a freshly-uploaded File and an asset-library selection (S3 asset key + assetId).
   */
  const handleBomImageSave = ({ file, assetUrl, assetKey, assetId, addToAssetLibrary }) => {
    setSendToAssetLibrary(!assetUrl && addToAssetLibrary === true);
    if (assetUrl) {
      setCroppedImage(assetUrl);
      setOriginalImage(assetUrl);
      setSelectedAssetKey(assetKey || null);
      setSelectedAssetId(assetId || null);
      setIsUploadAsset(true);
      setIsNewUploaded(true);
      setRemoveImage(false);
      setShowUploadModal(false);
      return;
    }
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result;
        if (base64?.length) {
          setCroppedImage(base64);
          setOriginalImage(base64);
        }
        setSelectedAssetKey(null);
        setSelectedAssetId(null);
        setIsUploadAsset(false);
        setIsNewUploaded(true);
        setRemoveImage(false);
        setShowUploadModal(false);
      };
      return;
    }
    setShowUploadModal(false);
  };

  const forms = (formData, uploadedDoc) => {
    formData.append('fileName', uploadedDoc?.name !== 'undefined' ? uploadedDoc?.name : `${refCode}_Image`);
    formData.append('devOrderId', devOrderId || null);
    formData.append('libId', libId || id);
    formData.append('bomType', BOMId || null);
    formData.append('document', uploadedDoc);
    formData.append('bomId', devOrderId ? id : null);
    formData.append('docType', 'Quality');
    formData.append('colourWay', null);
    formData.append('documentType', 'document');
  };

  const handleSelectRefype = async (value) => {
    setValue('bomComponentSubType', null);
    setBomComponentSubType(null);
    setValue('bomSubType', value, {
      shouldValidate: true,
    });
    setBomSubType(value);
    if (id && !isFromLibrary) {
      const oldObj = clonedBomData?.bomSubType;
      const newObj = value;
      const isSameValue = compareObjectWithKey(oldObj, newObj, 'name');

      addUpdateHighlightedKey(isSameValue, 'bomSubType');
    }
  };

  const handleSelectBOMComponentSubType = async (value) => {
    setValue('bomComponentSubType', value, {
      shouldValidate: false,
    });
    setBomComponentSubType(value);
    if (id && !isFromLibrary) {
      const oldObj = clonedBomData.bomComponentSubType;
      const newObj = value;
      const isSameValue = compareObjectWithKey(oldObj, newObj, 'name');

      addUpdateHighlightedKey(isSameValue, 'bomComponentSubType');
    }
  };

  const handleSelectTransport = async (value) => {
    setValue('transport', value, {
      shouldValidate: false,
    });
    setTransport(value);
    if (id && !isFromLibrary) {
      const oldObj = clonedBomData.transport;
      const newObj = value;
      const isSameValue = compareObjectWithKey(oldObj, newObj, 'name');

      addUpdateHighlightedKey(isSameValue, 'transport');
    }
  };

  const handleBrand = (value) => {
    setValue('brand', value?._id ? value?._id : null, {
      shouldValidate: false,
    });
    setBrand(value);

    setValue('subBrand', null, {
      shouldValidate: false,
    });
    setSubBrand(null);

    if (!value) {
      setSubBrandOption([]);
    }
  };

  const handleSubBrand = (value) => {
    setValue('subBrand', value?._id ? value?._id : null, {
      shouldValidate: false,
    });
    setSubBrand(value);
  };

  const handleCategory1 = (value) => {
    setValue('category1', value?._id ? value?._id : null, {
      shouldValidate: false,
    });
    setCategory1(value);
    if (catBasedOnPTData) {
      const relOkC2 = (opt) => {
        const rel = opt?.categoryOneId || opt?.catOneIds || [];
        const arr = Array.isArray(rel) ? rel : [rel];
        const ids = arr.map((x) => x?._id || x).filter(Boolean);
        return value ? ids?.includes(value?._id) : true;
      };
      if (category2 && !relOkC2(category2)) {
        setValue('category2', null, { shouldValidate: false });
        setCategory2(null);
      }
      const c1 = value;
      const c2 = category2;
      const c3Ok = (opt) => {
        const r1 = opt?.categoryOneId || opt?.catOneIds || [];
        const r2 = opt?.categoryTwoId || opt?.catTwoIds || [];
        const a1 = (Array.isArray(r1) ? r1 : [r1]).map((x) => x?._id || x).filter(Boolean);
        const a2 = (Array.isArray(r2) ? r2 : [r2]).map((x) => x?._id || x).filter(Boolean);
        return (c1 ? a1?.includes(c1?._id) : true) && (c2 ? a2?.includes(c2?._id) : true);
      };
      if (category3 && !c3Ok(category3)) {
        setValue('category3', null, { shouldValidate: false });
        setCategory3(null);
      }
      const c3 = category3;
      const c4Ok = (opt) => {
        const r1 = opt?.categoryOneId || opt?.catOneIds || [];
        const r2 = opt?.categoryTwoId || opt?.catTwoIds || [];
        const r3 = opt?.categoryThreeId || opt?.catThreeIds || [];
        const a1 = (Array.isArray(r1) ? r1 : [r1]).map((x) => x?._id || x).filter(Boolean);
        const a2 = (Array.isArray(r2) ? r2 : [r2]).map((x) => x?._id || x).filter(Boolean);
        const a3 = (Array.isArray(r3) ? r3 : [r3]).map((x) => x?._id || x).filter(Boolean);
        return (c1 ? a1?.includes(c1?._id) : true) && (c2 ? a2?.includes(c2?._id) : true) && (c3 ? a3?.includes(c3?._id) : true);
      };
      if (category4 && !c4Ok(category4)) {
        setValue('category4', null, { shouldValidate: false });
        setCategory4(null);
      }
    } else {
      if (category3) {
        setValue('category3', null, { shouldValidate: false });
        setCategory3(null);
      }
      if (category4) {
        setValue('category4', null, { shouldValidate: false });
        setCategory4(null);
      }
    }
  };

  const handleCategory2 = (value) => {
    setValue('category2', value?._id ? value?._id : null, {
      shouldValidate: false,
    });
    setCategory2(value);
    if (category3) {
      setValue('category3', null, {
        shouldValidate: false,
      });
      setCategory3(null);
    }
    if (category4) {
      setValue('category4', null, {
        shouldValidate: false,
      });
      setCategory4(null);
    }
  };

  const handleCategory3 = (value) => {
    setValue('category3', value?._id ? value?._id : null, {
      shouldValidate: false,
    });
    setCategory3(value);
    if (category4) {
      setValue('category4', null, {
        shouldValidate: false,
      });
      setCategory4(null);
    }
  };

  const handleCategory4 = (value) => {
    setValue('category4', value?._id ? value?._id : null, {
      shouldValidate: false,
    });
    setCategory4(value);
  };

  const handleSelectSizeUnit = async (value) => {
    setSizeUnitOfMeasure(value);
    if (id && !isFromLibrary) {
      const oldObj = clonedBomData.sizeUnitOfMeasure;
      const newObj = value;
      const isSameValue = compareObjectWithKey(oldObj, newObj, 'name');
      addUpdateHighlightedKey(isSameValue, 'size');
    }
  };

  const handleSelectWeightUnit = async (value) => {
    setweightUnitOfMeasure(value);
    if (id && !isFromLibrary) {
      const oldObj = clonedBomData.weightUnitOfMeasure;
      const newObj = value;
      const isSameValue = compareObjectWithKey(oldObj, newObj, 'name');
      addUpdateHighlightedKey(isSameValue, 'weight');
    }
  };

  const handleSelectQuantityUnit = async (value) => {
    setValue('quantityUnitOfMeasure', value);
    setQuantityUnitOfMeasure(value);
    if (id && !isFromLibrary) {
      const oldObj = clonedBomData.quantityUnitOfMeasure;
      const newObj = value;
      const isSameValue = compareObjectWithKey(oldObj, newObj, 'name');
      addUpdateHighlightedKey(isSameValue, 'quantity');
    }
  };

  const handleSelectFinals = async (value) => {
    setValue('finished', value?._id);
    setFinal(value);
    if (id && !isFromLibrary) {
      const oldObj = clonedBomData.finished;
      const newObj = value;
      const isSameValue = compareObjectWithKey(oldObj, newObj, 'name');

      addUpdateHighlightedKey(isSameValue, 'finished');
    }
  };

  const compareObjectArraysWithKey = (arr1, arr2, key) => {
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
    if (arr1.length !== arr2.length) return false;

    const sortByKey = (arr) => [...arr].sort((a, b) => (a?.[key] || '').localeCompare(b?.[key] || ''));

    const sorted1 = sortByKey(arr1);
    const sorted2 = sortByKey(arr2);

    return sorted1.every((item, index) => item?.[key] === sorted2[index]?.[key]);
  };

  const handleSelectPlacement = async (selectedValues) => {
    const ids = Array.isArray(selectedValues) ? selectedValues.map((v) => v?.value) : [];
    setValue('newPlacement', ids, {
      shouldValidate: false,
    });
    setPlacementValue(selectedValues);
    if (id && !isFromLibrary) {
      const oldArr = clonedBomData.newPlacement || [];
      const newArr = selectedValues || [];
      const isSameValue = compareObjectArraysWithKey(oldArr, newArr, 'name');
      addUpdateHighlightedKey(isSameValue, 'newPlacement');
    }
  };

  useEffect(() => {
    async function fetchAPI() {
      setShowLoader(true);
      await Promise.all([
        dispatch(action.fetchBomReferenceType({ bomTypeId: BOMId })),
        dispatch(masterAction.getFinalsDetails({ isActive: true })),
        dispatch(masterAction.getPlacementDetails({ isActive: true, bomTypeId: BOMId })),
        dispatch(masterAction.getBrandDetails({ accessedFrom: '', loggedInUserId, isActive: true })),
        dispatch(masterAction.getCategory1Details({ accessedFrom: '', categoryType: 1, isActive: true, loggedInUserId })),
        dispatch(masterAction.getCategory2Details({ accessedFrom: '', categoryType: 2, isActive: true, loggedInUserId })),
        dispatch(masterAction.getSubBrandAccess()),
      ]);

      if (userInfo && loggedInUserId) {
        if (libId !== undefined) {
          await dispatch(
            supplierAction.fetchProductSupplierListAction({
              devOrderId,
            }),
          );
        }
        await getCustomBomAttributeList();
        await Promise.all([
          await dispatch(colourAction.fetchColorLibrary({ loggedInUserId })),
          dispatch(action.fetchBomLibarayComposition({ isActive: 1, loggedInUserId, bomTypeId: BOMId })),
          dispatch(action.fetchBomLibarayUnitOfMeasure({ isActive: true, loggedInUserId })),
          dispatch(supplierAction.fetchTierSSupplierListAction({ isWithFactory: true, tierType: 'Tier2' })),
          dispatch(supplierAction.fetchTierSSupplierListAction({ isWithFactory: true, tierType: 'Tier3' })),
          dispatch(supplierAction.fetchTierSSupplierListAction({ isWithFactory: true, tierType: 'Tier4' })),
          dispatch(supplierAction.fetchTierSSupplierListAction({ isWithFactory: true, tierType: 'Tier1' })),
        ]);
      }
      if (!editState.mode) {
        devOrderId = null;
      }
      setShowLoader(false);
    }
    fetchAPI();
    return () => {
      dispatch(supportingAction.deleteAllUnSavedSupportingDocuments());
    };
  }, []);

  useEffect(() => {
    const callingCategoryapis = async () => {
      if (category1 && category2) {
        await dispatch(
          masterAction.getCategory3Details({
            categoryOneId: category1._id,
            categoryTwoId: category2._id,
            categoryType: 3,
            isActive: true,
            loggedInUserId,
          }),
        );
      }
      if (category1 && category2 && category3) {
        await dispatch(
          masterAction.getCategory4Details({
            categoryOneId: category1._id,
            categoryTwoId: category2._id,
            categoryThreeId: category3._id,
            categoryType: 4,
            isActive: true,
            loggedInUserId,
          }),
        );
      }
    };

    callingCategoryapis();
  }, [category1, category2, category3, dispatch, loggedInUserId]);

  useEffect(() => {
    if (activeReferenceType.length === 1 && !bomSubType) {
      const singleOption = activeReferenceType[0];
      handleSelectRefype(singleOption);
    }
  }, [activeReferenceType, bomSubType, handleSelectRefype]);

  useEffect(() => {
    if (BOMId && bomSubType?._id) {
      dispatch(action.fetchBomComponentSubType({ bomTypeId: BOMId, componentTypeId: bomSubType._id }));
    }
  }, [bomSubType?._id, BOMId]);

  const valueCalled = (value) => {
    if (value.image || value.fullImage) {
      setImageState({
        mode: true,
        data: value.fullImage ? value.fullImage : value.image,
      });
    }
    if (value?.finished) {
      let arr = [];
      if (!isEmpty(finalList) && typeof value?.finished === 'string') {
        arr = finalList.filter((ele) => ele._id === value?.finished);
        setFinal(arr?.[0]);
      } else {
        setFinal(value?.finished);
      }
      setValue('finished', value?.finished?._id);
    }
    if (value?.newPlacement) {
      const newValue = value?.newPlacement?.map((item) => ({
        label: item.name,
        value: item._id,
      }));

      setPlacementValue(newValue);
      setValue('newPlacement', newValue);
    }
    if (value.quantityUnitOfMeasure) {
      setQuantityUnitOfMeasure(value.quantityUnitOfMeasure);
      setValue('quantityUnitOfMeasure', value.quantityUnitOfMeasure, {
        shouldValidate: true,
      });
    }
    if (value.weightUnitOfMeasure) {
      setweightUnitOfMeasure(value.weightUnitOfMeasure);
      setValue('weightUnitOfMeasure', value.weightUnitOfMeasure, {
        shouldValidate: true,
      });
    }
    if (value.pricePerUnitCurrency) {
      setPricePerUnitCurrency({ label: value.pricePerUnitCurrency, value: value.pricePerUnitCurrency });
      setValue(
        'pricePerUnitCurrency',
        { label: value.pricePerUnitCurrency, value: value.pricePerUnitCurrency },
        {
          shouldValidate: true,
        },
      );
    }
    if (value.pricePerUnit) {
      setValue('pricePerUnit', value.pricePerUnit, {
        shouldValidate: true,
      });
    }
    if (value.sizeUnitOfMeasure) {
      setSizeUnitOfMeasure(value.sizeUnitOfMeasure);
      setValue('sizeUnitOfMeasure', value.sizeUnitOfMeasure, {
        shouldValidate: true,
      });
    }
  };

  const valueForSupplier = (value) => {
    if (!isEmpty(value?.suppliers)) {
      let data = value?.suppliers
        .filter((item) => item)
        .map((item) => ({
          label: item.name,
          value: item._id,
        }));
      if (data?.[0].label === '' || data?.[0].label === null) {
        data = [];
      }
      selectMultipleSuppliers(data);
    }
  };

  const colourWayItem = (item) => {
    return item?.colourWayId?._id
      ? {
          ...item,
          tier1Supplier: item?.tier1Supplier,
          componentSupplier: item?.componentSupplier,
          supplierName: item.tier1Supplier && item?.tier1Supplier?.name,
          componentSupplierName: item.componentSupplier && item?.componentSupplier?.name,
          supplierList: item?.supplierList?.length && item.supplierList.map((ele) => (ele.name = ele.factoryName)) && uniqBy([...item.supplierList], 'name'),
          colourWayId: item?.colourWayId?._id,
          colourWayName: item?.colourWayId?.name,
          colourWayRefName: item?.colourRefsDataAsPerSuppliers?.length && item.colourRefsDataAsPerSuppliers.map((ele) => ele?.colourRef?.name),
        }
      : null;
  };

  const colourRefToSuppplier = (item, value) => {
    return item.colourRefsDataAsPerSuppliers.map((k) => ({
      ...k,
      colourRef: k?.colourRef?._id ?? null,
      supplier: k?.supplier?._id ?? null,
      autoApprove: value?.colorAutoApprove ?? k?.autoApprove,
    }));
  };

  const valueForColourRef = (value) => {
    if (!isEmpty(value?.colourWayRefsData)) {
      const colorWayId = value.colourWayRefsData.map((item) => {
        return colourWayItem(item);
      });
      let colorWayData = [];
      if (colorWayId && colorWayId.indexOf(null) === -1) {
        colorWayData = colorWayId.map((item) => ({
          ...item,
          colourRefsDataAsPerSuppliers: colourRefToSuppplier(item, value),
        }));
      } else {
        colorWayData = forColourWay(colorWayId);
      }
      const data = {
        list: colorWayData,
      };
      setColorWay({ ...data });
    }
  };

  const forColourWay = (colorWayId) => {
    return colorWayId.map((item) => ({
      ...item,
      colourRefsDataAsPerSuppliers: [
        {
          colourRef: null,
          colourRefNumber: '',
          supplier: null,
          comment: '',
          commentDate: null,
          approveBy: null,
          tier1Supplier: null,
          componentSupplier: null,
          colourRefName: null,
          colourPlacement: null,
        },
      ],
    }));
  };

  const forBomSupps = (value) => {
    if (value?.BOMSupplier) {
      selectBomSuppliers(uniqBy([...(value?.BOMSupplier ?? [])], 'name'));
      setUpSupplier(uniqBy([...(value?.BOMSupplier ?? [])], 'name'));
      setValue('BOMSupplier', value?.BOMSupplier, {
        shouldValidate: true,
      });
    }
    if (!isEmpty(value?.combinationSuppliers)) {
      const returnArray = [];
      value?.combinationSuppliers?.forEach((element) => {
        returnArray.push(element.componentSupplier);
      });
      setShowNewTable(true);
      setUpSupplier([...returnArray]);
      setCombinedDataArray([...(value.combinationSuppliers ?? [])]);
    }
    if (value.bomSubType) {
      setBomSubType(value.bomSubType);
      setValue('bomSubType', value.bomSubType, {
        shouldValidate: true,
      });
    }
  };

  const setBomComponentSubTypeData = (value) => {
    if (value?.bomComponentSubType) {
      const selectedData = bomComponentSubTypeList?.find((option) => option?._id === value?.bomComponentSubType);
      if (selectedData) {
        setBomComponentSubType({ name: selectedData?.name, _id: selectedData?._id });
        setValue(
          'bomComponentSubType',
          { name: selectedData?.name, _id: selectedData?._id },
          {
            shouldValidate: false,
          },
        );
      } else {
        setBomComponentSubType(null);
        setValue('bomComponentSubType', null);
      }
    }
  };
  const forDataIndex = () => {
    return itemList && itemList.length > 0 ? itemList.findIndex((item) => item?._id === id) : 0;
  };
  useEffect(() => {
    if (id && bomDetailsBasedOnId && !bomApiLoder && !isFromLibrary) {
      const value = bomDetailsBasedOnId;
      setBomComponentSubTypeData(value);
    } else if (id && isFromLibrary) {
      const dataIndex = forDataIndex();
      const value = itemList[dataIndex];
      setBomComponentSubTypeData(value);
    }
  }, [id, setValue, itemList, bomComponentSubTypeList, bomApiLoder, bomDetailsBasedOnId, isFromLibrary]);

  const ifValueImage = (value) => {
    if (value.image && value.image !== noImage) {
      const image = value?.image;
      setCroppedImage(image);
      setPrevCroppedImage(image);
      setIsNewUploaded(false);
    } else {
      setCroppedImage(noImage);
      setPrevCroppedImage('');
    }
  };

  const forNewValues = (value) => {
    setBrand(value.brand);
    setCategory1(value?.category1);
    setCategory2(value?.category2);
    setCategory3(value?.category3);
    setCategory4(value?.category4);

    setValue('brand', value.brand?._id ? value.brand?._id : null, {
      shouldValidate: false,
    });
    setSubBrand(value?.subBrand);
    setValue('subBrand', value?.subBrand?._id ? value?.subBrand?._id : null, {
      shouldValidate: false,
    });
    const initPtId = value?.productTypeId?._id || value?.productType?._id || null;
    if (initPtId) {
      const ptOpt = (Array.isArray(pcTypeList) ? pcTypeList : [])?.find((o) => (o?._id || o?.value) === initPtId) || {
        _id: initPtId,
        name: value?.productTypeId?.name || value?.productType?.name || '',
      };
      setSelectedProductType(ptOpt);
    } else {
      setSelectedProductType(null);
    }
    setValue('productType', initPtId, {
      shouldValidate: false,
    });
    setValue('category1', value?.category1?._id ? value?.category1?._id : null, {
      shouldValidate: false,
    });
    setValue('category2', value?.category2?._id ? value?.category2?._id : null, {
      shouldValidate: false,
    });
    setValue('category3', value?.category3?._id ? value?.category3?._id : null, {
      shouldValidate: false,
    });
    setValue('category4', value?.category4?._id ? value?.category4?._id : null, {
      shouldValidate: false,
    });
  };

  const setBomModalData = (value) => {
    if (value) {
      setState((prevState) => ({
        ...prevState,
        clonedBomData: value,
      }));
      setImageState({
        mode: true,
        data: value.fullImage ? value.fullImage : value.image,
      });
      setEditState({
        mode: true,
        data: value,
      });

      setOldDocIds(value?.docIds);

      valueCalled(value);
      forNewValues(value);
      forBomSupps(value);
      setRefCode(value.referenceCode);
      setValue('referenceCode', value.referenceCode, {
        shouldValidate: true,
      });

      setValue('bomDescription', value.bomDescription, {
        shouldValidate: true,
      });
      setBomDescriptionCount(value.bomDescription?.length || 0);
      setValue('size', value.size, {
        shouldValidate: true,
      });
      setValue('weight', value.weight, {
        shouldValidate: true,
      });
      setValue('additionalInfo', value.additionalInfo, {
        shouldValidate: true,
      });
      setValue('quantity', value.quantity, {
        shouldValidate: true,
      });
      setValue('placement', value.placement, {
        shouldValidate: true,
      });
      setValue('newPlacement', value?.newPlacement ? value?.newPlacement : [], {
        shouldValidate: false,
      });

      if (value?.transport) {
        setTransport(value?.transport);
        setValue('transport', value?.transport, {
          shouldValidate: false,
        });
      }

      if (value?.quality) {
        setQuality(value?.quality);
        setValue('quality', value?.quality, {
          shouldValidate: false,
        });
      }
      setCustomBom({
        composition: value?.composition?.length
          ? value.composition
          : [
              {
                percentage: null,
                composition: null,
              },
            ],
      });
      if (value?.composition?.length) {
        validateTotalPercentage(value?.composition);
      }
      valueForSupplier(value);
      valueForColourRef(value);
      ifValueImage(value);

      setState((prevState) => ({
        ...prevState,
        highlightedKeys: value.highlightedKeys || [],
      }));
      setBomDocumentState((previousState) => ({
        ...previousState,
        cardList:
          value?.subBomList?.length > 0
            ? value?.subBomList
            : [
                {
                  isSave: false,
                  error: false,
                  isDefault: true,
                  composition: [
                    {
                      percentage: null,
                      composition: null,
                    },
                  ],
                },
              ],
      }));
      setSubBOMSwitch(value?.subBOMSwitch);
    }
  };

  useEffect(() => {
    if (id && !bomApiLoder && bomDetailsBasedOnId && !isFromLibrary) {
      const value = bomDetailsBasedOnId;
      setBomModalData(value);
    } else if (isFromLibrary && id) {
      const dataIndex = forDataIndex();
      const value = itemList[dataIndex];
      setBomModalData(value);
    }
    setEmptyDocs(true);
    setRenderSuppotingDoc(true);
  }, [id, setValue, itemList, bomDetailsBasedOnId, bomApiLoder, isFromLibrary]);
  useEffect(() => {
    return () => {
      reset();
      setEditState({ mode: false, data: null });
      setCustomBom({
        composition: [
          {
            percentage: null,
            composition: null,
          },
        ],
      });
      setState((prev) => ({ ...prev, clonedBomData: null, highlightedKeys: [], bomApiLoder: false }));
      setColorWay({
        list: [
          {
            colourWayId: null,
            componentSupplier: null,
            supplierList: [],
            tier1Supplier: null,
            suppilerName: '',
            componentSupplierName: '',
            colourWayName: '',
            colourWayRefName: '',
            colourRefsDataAsPerSuppliers: [
              {
                colourRef: null,
                colourRefNumber: '',
                supplier: null,
                comment: '',
                commentDate: null,
                approveBy: null,
                tier1Supplier: null,
                componentSupplier: null,
                colourRefName: null,
                colourPlacement: null,
              },
            ],
          },
        ],
      });
      dispatch(clearBomEditModalData());
    };
  }, [dispatch]);
  const handleBomSupplier = async (supp) => {
    if (supp) {
      setUpSupplier([supp]);
      selectBomSuppliers([supp]);
    } else {
      setUpSupplier([]);
      selectBomSuppliers([]);
    }
    if (id && !isFromLibrary) {
      const oldObj = clonedBomData?.BOMSupplier?.length && clonedBomData?.BOMSupplier?.[0];
      const newObj = supp;
      const isSameValue = compareObjectWithKey(oldObj, newObj, 'name');
      addUpdateHighlightedKey(isSameValue, 'BOMSupplier');
    }
  };

  const handleRenderSupportingDoc = (options) => {
    if (isImport) {
      options.libId = editState?.data?.libId ?? null;
      options.bomId = editState?.data?._id ?? null;
      options.fromBomLibrary = false;
    } else {
      options.fromBomLibrary = true;
      options.libId = editState?.data?._id ?? null;
    }
    return (
      <SupportingDocumentTable
        data={{ ...options }}
        emptyDocs={emptyDocs}
        removeLibId={removeLibId}
        setFinalDocuments={setFinalDocuments}
        referenceOptions={referenceOptions}
      />
    );
  };

  const removeImg = () => {
    setCroppedImage(noImage);
    setRemoveImage(true);
    setSelectedAssetKey(null);
    setSelectedAssetId(null);
    setIsUploadAsset(false);
    setShowImageRemoveConfirmationPopup(!showImageRemoveConfirmationPopup);
  };

  const addComponentType = () => {
    setShowComponentTypePopup(true);
  };

  const addComponentSubType = () => {
    setShowComponentSubTypePopup(true);
  };

  const saveComponentType = async (dataObj) => {
    setShowSubTypeLoader(true);
    const res = await dispatch(action.saveBomSubTypesAction(dataObj, t));
    if (res) {
      await dispatch(action.fetchBomReferenceType({ bomTypeId: BOMId }));
      setShowComponentTypePopup(!showComponentTypePopup);
    }
    setShowSubTypeLoader(false);
  };

  const saveComponentSubType = async (dataObj) => {
    if (!bomSubType?._id) {
      toasterMsg('Please Select Component Sub-Type', 'danger');
      return;
    }
    const newObj = {
      names: dataObj.bomSubTypes,
      bomTypeId: dataObj.bomTypeId,
      componentTypeId: bomSubType._id,
    };
    setShowSubTypeLoader(true);
    const res = await dispatch(action.saveComponentSubTypesAction(newObj, t));
    if (res) {
      await dispatch(action.fetchBomComponentSubType({ bomTypeId: dataObj?.bomTypeId, componentTypeId: bomSubType?._id }));
      setShowComponentSubTypePopup(!showComponentSubTypePopup);
    }
    setShowSubTypeLoader(false);
  };

  const saveCompositionType = async (dataObj) => {
    setShowSubTypeLoader(true);
    const res = await dispatch(masterAction.saveToSystemMaster(dataObj, t, 'fromBom'));
    if (res) {
      await dispatch(
        action.fetchBomLibarayComposition({
          isActive: 1,
          loggedInUserId,
          bomTypeId: BOMId,
        }),
      );
      setShowCompositionModal(!showCompositionModal);
    }
    setShowSubTypeLoader(false);
  };

  const handleSelectPricePerUnitCurrency = async (value) => {
    setPricePerUnitCurrency(value);
    if (id && !isFromLibrary) {
      const oldObj = clonedBomData.pricePerUnitCurrency;
      const newObj = value;
      const isSameValue = compareObjectWithKey(oldObj, newObj, 'name');
      addUpdateHighlightedKey(isSameValue, 'pricePerUnitCurrency');
    }
  };

  const bomTypes = () => {
    return (
      <>
        <Col className="add-form" md={3} lg={2}>
          <div className="common-input-control  mb-0 add-common-form">
            <p className="field-name text-bold">
              {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.BOM_TYPE')}
              <span className="asterisk">*</span>
            </p>
            <input
              name="bomType"
              className="form-control f-14"
              {...register('bomType', { required: false })}
              type="text"
              defaultValue={BOMProperty?.name ? BOMProperty?.name : ''}
              disabled
            />
          </div>
        </Col>

        <Col className="add-form" md={3} lg={2}>
          <div className={highlightedKeys?.includes('referenceCode') && highlightedField}>
            <div className="highlight-form mb-0 common-input-control">
              <p className="field-name text-bold">
                {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_CODE')}
                <span className="asterisk">*</span>
              </p>
              <input
                type="text"
                name="referenceCode"
                {...register('referenceCode', {
                  required: true,
                  validate: (value) => !!value.trim() || 'no whitespaces.',
                })}
                placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ENTER_COMPONENT_CODE')}
                className="form-control  f-14"
              />
              {errors.referenceCode && <span className="error-message">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_CODE_REQUIRED')} </span>}
            </div>
          </div>
        </Col>
        <Col className="add-form" md={3} lg={2}>
          <FormGroup className={highlightedKeys?.includes('bomDescription') && highlightedField}>
            <div className="highlight-form mb-0 common-input-control">
              <p className="field-name text-bold">
                {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_DESCRIPTION')}
                <span className="asterisk">*</span>
              </p>

              <input
                type="text"
                name="bomDescription"
                {...register('bomDescription', {
                  required: true,
                  maxLength: {
                    value: 200,
                    message: t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_DESCRIPTION_MAX_LENGTH') || 'Component description must not exceed 200 characters',
                  },
                })}
                placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ENTER_COMPONENT_DESCRIPTION')}
                className="form-control f-14"
                onChange={(e) => {
                  setValue('bomDescription', e.target.value, { shouldValidate: true });
                  setBomDescriptionCount(e.target.value.length);
                }}
              />
              <div className="d-flex w-100">
                <div className="text-right w-100">
                  <span className="text-success">
                    {bomDescriptionCount === 0 && !inputBomDescription ? '0/200' : `${bomDescriptionCount || inputBomDescription?.length || 0}/200`}
                  </span>
                </div>
              </div>
            </div>
            {errors.bomDescription && (
              <span className="error-message">
                {errors.bomDescription.type === 'required'
                  ? t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_DESCRIPTION_REQUIRED')
                  : errors.bomDescription.message}
              </span>
            )}
          </FormGroup>
        </Col>
        <Col className="add-form" md={3} lg={2}>
          <FormGroup>
            <div
              className={
                highlightedKeys?.includes('BOMSupplier')
                  ? `${highlightedFieldCustomReactSelect} common-react-select`
                  : `${customReactSelect} common-react-select`
              }
            >
              <p className="field-name text-bold">
                {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUPLIER')}
                <span className="asterisk asterisk-req-green">*</span>
              </p>

              <Select
                {...register('BOMSupplier', {
                  required: false,
                })}
                name="BOMSupplier"
                options={componentSupplierOptions}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option._id}`}
                value={BomSuppliers}
                styles={customStyles}
                onChange={handleBomSupplier}
                placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_COMPONENT_SUPLIER')}
                isDisabled={showNewTable}
                isClearable
                className="common-select"
                classNamePrefix="common-select"
              />
            </div>
          </FormGroup>
        </Col>
        <Col className="add-form" md={3} lg={2}>
          <FormGroup>
            <div
              className={
                highlightedKeys?.includes('transport') ? `${highlightedFieldCustomReactSelect} common-react-select` : `${customReactSelect} common-react-select`
              }
            >
              <p className="field-name text-bold">
                {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.TRANSPORT')}
                <span className="asterisk asterisk-req-green">*</span>
              </p>

              <Select
                {...register('transport', {
                  required: false,
                })}
                name="transport"
                options={transportArray}
                getOptionLabel={(option) => `${option.label}`}
                getOptionValue={(option) => `${option._id}`}
                value={transport}
                styles={customStyles}
                onChange={handleSelectTransport}
                placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_TRANSPORT')}
                isClearable
                className="common-select"
                classNamePrefix="common-select"
              />
            </div>
          </FormGroup>
        </Col>
        <Col className="add-form" md={3} lg={2}>
          <FormGroup className="w-100">
            <div className="d-flex align-items-top">
              <div className="flex-fill common-react-select max-w-100">
                <div className={highlightedKeys?.includes('bomSubType') ? highlightedFieldCustomReactSelect : customReactSelect}>
                  <p className="field-name text-bold">
                    {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_TYPE')}
                    <span className="asterisk">*</span>
                  </p>

                  <Select
                    {...register('bomSubType', {
                      required: true,
                    })}
                    name="bomSubType"
                    options={activeReferenceType}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    value={bomSubType}
                    styles={customStyles}
                    onChange={handleSelectRefype}
                    placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_COMPONENT_TYPE')}
                    isClearable
                    className="common-select"
                    classNamePrefix="common-select"
                  />
                </div>
                <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                  <button
                    type="button"
                    aria-label="add"
                    onClick={() => {
                      addComponentType();
                    }}
                    className="btn mr-0 btn-absolute btn-outline"
                  >
                    <i className="icon-Add" />
                  </button>
                </CustomTooltip>
                {errors.bomSubType && <span className="error-message">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_TYPE_REQUIRED')} </span>}
              </div>
            </div>
          </FormGroup>
        </Col>
      </>
    );
  };

  const handleProdSupplier = (newEvent, i) => {
    const arr = cloneDeep(combinedDataArray);
    arr[i].productSupplier = newEvent;
    setCombinedDataArray([...arr]);
  };

  const handleCompSupplier = async (compSupplier, i) => {
    const array = cloneDeep(combinedDataArray);
    array[i].componentSupplier = compSupplier;
    selectBomSuppliers([]);
    setUpSupplier([]);
    setValue('BOMSuppplier', []);
    if (array.length === 1) {
      if (colorWay?.list?.[0].colourWayId) {
        const rows = [...colorWay.list];
        rows.forEach((row) => {
          row.componentSupplier = compSupplier;
        });
        const obj = {
          ...colorWay,
          list: rows,
        };
        setColorWay(obj);
      }
    } else if (colorWay?.list?.[0].colourWayId) {
      const rows = [...colorWay.list];
      rows.forEach((row) => {
        row.componentSupplier = null;
      });
      const obj = {
        ...colorWay,
        list: rows,
      };
      setColorWay(obj);
    }
    setCombinedDataArray([...array]);
    upSupplier.length - 1 === i ? upSupplierChanges(compSupplier, i) : removePreviousOption(compSupplier, i);
  };

  const removePreviousOption = (compSupplier, i) => {
    return upSupplier[i]?._id !== compSupplier?._id
      ? upSupplier.splice(i, 1) && setUpSupplier(uniqBy([...upSupplier, compSupplier], '_id'))
      : setUpSupplier(uniqBy([...upSupplier, compSupplier], '_id'));
  };

  const upSupplierChanges = (compSupplier, i) => {
    const arr = cloneDeep(upSupplier);
    arr[i] = compSupplier;
    setUpSupplier(arr);
  };

  const addCombinedArray = (e) => {
    e.preventDefault();
    const array = cloneDeep(combinedDataArray);
    array.push({ componentSupplier: null, productSupplier: null });
    setCombinedDataArray([...array]);
    findIfCombinedDataNull() && setShowRequirmentError(false);
  };

  const deleteCombinedArray = (e, i) => {
    e.preventDefault();
    const array = cloneDeep(combinedDataArray);
    array.splice(i, 1);
    if (array.length === 1) {
      if (colorWay?.list?.[0].colourWayId) {
        const rows = [...colorWay.list];
        rows.forEach((row) => {
          row.componentSupplier = array?.[0].componentSupplier;
        });
        const obj = {
          ...colorWay,
          list: rows,
        };
        setColorWay(obj);
      }
    }
    if (isEmpty(array)) {
      array.push({ componentSupplier: null, productSupplier: null });
    }
    setCombinedDataArray([...array]);
  };
  const onSwitchChange = async (e) => {
    const value = e.target.checked;
    setSubBOMSwitch(value);
  };

  const toogleAddComposition = (e) => {
    e.preventDefault();
    if (columnHeader?.length === 5) {
      toasterMsg(t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.MAX_COLUMNS'), 'danger');
      return;
    }
    const copyState = cloneDeep(bomDocumentState?.cardList);
    copyState.forEach((row, rowIndex) => {
      const column = [...row.composition];
      column.push({
        percentage: null,
        composition: '',
      });
      const path = commonPath(rowIndex, 'composition').COMMON_PATH;
      set(copyState, path, column);
    });
    setCoumnHeader((prevState) => [...prevState, 'BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION']);
    setBomDocumentState((previousState) => ({ ...previousState, cardList: copyState }));
  };

  const componentSupplierOptions = useMemo(() => {
    if (isFromLibrary) {
      if (tier2Suppliers?.length > 0) {
        return tier2Suppliers;
      }
    }
    if (!isFromLibrary) {
      if (suppliers?.length > 0 && tier2Suppliers?.length > 0 && tier1Suppliers?.length) {
        const productSupplireIds = suppliers?.map((vl) => vl._id);
        const productSupplierDetails = productSupplireIds?.filter((vl) => productSupplireIds?.includes(vl._id));
        return concat(productSupplierDetails, tier2Suppliers);
      }
      if (tier2Suppliers?.length > 0) {
        return tier2Suppliers;
      }
      return [];
    }
  }, [tier2Suppliers?.length, suppliers?.length, isFromLibrary, tier1Suppliers?.length]);

  const toogleDeleteComposition = (e, index) => {
    e.preventDefault();
    const copyState = cloneDeep(bomDocumentState?.cardList);
    copyState.forEach((row, rowIndex) => {
      const column = [...row.composition];
      if (index >= 0 && index < column.length) {
        column.splice(index, 1);
      }
      const path = commonPath(rowIndex, 'composition').COMMON_PATH;
      set(copyState, path, column);
    });
    setBomDocumentState((previousState) => ({ ...previousState, cardList: copyState }));
    setCoumnHeader((prevState) => {
      const indexToRemove = prevState.findIndex((item) => item === 'BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION');
      if (indexToRemove === -1) {
        return prevState;
      }
      return [...prevState.slice(0, indexToRemove), ...prevState.slice(indexToRemove + 1)];
    });
  };

  const handleSelectDynamic = (selectedOption, key, dynamicId) => {
    const copyState = cloneDeep(clonedBomData);
    const dynamicArray = [];
    let isSameValue = null;

    if (id && !isFromLibrary && copyState?.dynamicColumn && count) {
      const findOldData = copyState?.dynamicColumn.find((e) => (e?.colId ? e?.colId?._id === dynamicId : e?._id === dynamicId));
      const findFieldType = customAttributeBomList?.find((ele) => ele._id === dynamicId && ele.bomTypeID === BOMProperty?._id);

      if (findOldData && findFieldType) {
        if (findFieldType.type === 'text') {
          const oldValue = findOldData.valueText || '';
          const newValue = selectedOption || '';
          isSameValue = oldValue === newValue;
        } else if (findFieldType.type === 'Multi Dropdown') {
          const oldIds = Array.isArray(findOldData.valueId) ? findOldData.valueId.map((opt) => opt?._id || opt).sort() : [];
          const newIds = Array.isArray(selectedOption) ? selectedOption.map((opt) => opt?.value || opt?._id || opt).sort() : [];
          isSameValue = JSON.stringify(oldIds) === JSON.stringify(newIds);
        } else {
          const oldId = findOldData.valueId?._id || findOldData.valueId || findOldData.optionsValue?._id || findOldData.optionsValue || null;
          const newId = selectedOption?._id || selectedOption?.value || selectedOption || null;
          isSameValue = oldId === newId;
        }
        addUpdateHighlightedKey(isSameValue, `dynamicColumn_${dynamicId}`);
      }
    }

    if (!isEmpty(customAttributeBomList)) {
      customAttributeBomList.forEach((ele) => {
        if (ele._id === dynamicId && ele.bomTypeID === BOMProperty?._id) {
          if (ele.type === 'text') {
            ele.valueText = selectedOption;
          } else if (ele.type === 'Multi Dropdown') {
            ele.optionsValue = selectedOption;
            ele.valueId = selectedOption?.map((opt) => ({
              _id: opt.value || opt._id,
              keyName: opt.label || opt.keyName,
            }));
          } else {
            ele.optionsValue = selectedOption;
            ele.valueId = selectedOption?.value || selectedOption;
          }
          dynamicArray.push(ele);
        } else if (checkArray(copyState?.dynamicColumn)) {
          const findOldData = copyState?.dynamicColumn.find((e) => (e?.colId ? e?.colId?._id === ele?._id : e?._id === ele?._id));

          if (!isEmpty(findOldData)) {
            dynamicArray.push({
              ...ele,
              valueText: findOldData.valueText || ele.valueText,
              valueId: findOldData.valueId || ele.valueId,
              optionsValue: findOldData.optionsValue || ele.optionsValue,
            });
          } else {
            dynamicArray.push(ele);
          }
        } else {
          dynamicArray.push(ele);
        }
      });
    }

    if (copyState?.dynamicColumn?.length > 0) {
      copyState.dynamicColumn = copyState.dynamicColumn.map((item) => {
        const updatedItem = dynamicArray.find((newItem) => newItem._id === item._id || item?.colId === item?._id);
        return updatedItem || item;
      });
    }

    setState((prevState) => ({
      ...prevState,
      clonedBomData: {
        ...prevState.clonedBomData,
        dynamicColumn: dynamicArray.filter((ele) => ele.bomTypeID === BOMProperty?._id),
      },
    }));
  };

  const currencyOptions = useMemo(() => {
    return currencyCodes?.map((currKey) => convertSelectLabel(currKey, true));
  }, [currencyCodes?.length]);

  useEffect(() => {
    const compositionArray = (customBom?.composition ?? []).map((item) => item?.composition?._id).filter((id) => id != null);
    if (compositionArray?.length > 0) {
      dispatch(
        masterAction.getCompositionProcessDetails({
          loggedInUserId,
          bomTypeId: BOMProperty?._id,
          compositionMasterIds: compositionArray,
        }),
      );
    }
  }, [customBom.composition, BOMProperty?._id]);

  const forTop = () => {
    return (
      <div className="form-container">
        <div className="row">
          {bomTypes()}
          <Col md={12}>
            <Row>
              <Col className="add-form" md={3} lg={2}>
                <FormGroup className="w-100">
                  <div className="d-flex align-items-top">
                    <div className="flex-fill common-react-select max-w-100">
                      <div className={highlightedKeys?.includes('bomComponentSubType') ? highlightedFieldCustomReactSelect : customReactSelect}>
                        <p className="field-name text-bold">
                          {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUB_TYPE')}
                          <span className="asterisk asterisk-req-green">*</span>
                        </p>
                        <Select
                          {...register('bomComponentSubType', {
                            required: false,
                          })}
                          name="bomComponentSubType"
                          options={bomComponentSubTypeList?.filter((data) => data?.isActive)}
                          getOptionLabel={(option) => `${option.name}`}
                          getOptionValue={(option) => `${option._id}`}
                          value={bomComponentSubType}
                          styles={customStyles}
                          onChange={handleSelectBOMComponentSubType}
                          placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_COMPONENT_SUB_TYPE')}
                          isClearable
                          className="common-select"
                          classNamePrefix="common-select"
                        />
                      </div>
                      <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                        <button
                          type="button"
                          aria-label="add"
                          onClick={() => {
                            addComponentSubType();
                          }}
                          className="btn mr-0 btn-outline btn-absolute"
                        >
                          <i className="icon-Add" />
                        </button>
                      </CustomTooltip>
                    </div>
                  </div>
                </FormGroup>
              </Col>

              <Col className="add-form">
                <FormGroup className={highlightedKeys?.includes('size') ? highlightedFieldClass : 'd-flex'}>
                  <div className="highlight-form mb-0 common-input-control flex-fill">
                    <p className="field-name text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SIZE')}</p>
                    <input
                      type="text"
                      name="size"
                      placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ENTER_SIZE')}
                      {...register('size', { required: false })}
                      className="form-control"
                    />
                  </div>
                  <div className="size-uom mb-0 common-react-select">
                    <p className="field-name text-bold">&nbsp;</p>
                    <Select
                      {...register('sizeUnitOfMeasure', {
                        required: false,
                      })}
                      name="sizeUnitOfMeasure"
                      options={UnitOfMeasure}
                      getOptionLabel={(option) => `${option.name}`}
                      getOptionValue={(option) => `${option._id}`}
                      value={sizeUnitOfMeasure}
                      styles={customStyles}
                      onChange={handleSelectSizeUnit}
                      placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.UOM')}
                      isClearable
                      className="common-select"
                      classNamePrefix="common-select"
                    />
                    {errors.sizeUnitOfMeasure && <span className="error-message">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.UOM_REQUIREDS')}</span>}
                  </div>
                </FormGroup>
              </Col>
              <Col className="add-form">
                <FormGroup className={highlightedKeys?.includes('weight') ? highlightedFieldClass : 'd-flex'}>
                  <div className="highlight-form mb-0 common-input-control flex-fill">
                    <p className="field-name text-bold">
                      {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.WEIGHT')}
                      <span className="asterisk asterisk-req-green ">*</span>
                    </p>

                    <input
                      type="text"
                      name="weight"
                      {...register('weight', { required: false })}
                      placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ENTER_WEIGHT')}
                      className="form-control"
                    />
                  </div>
                  <div className="size-uom mb-0 common-react-select">
                    <p className="field-name text-bold">&nbsp;</p>
                    <Select
                      {...register('weightUnitOfMeasure', {
                        required: false,
                      })}
                      name="weightUnitOfMeasure"
                      options={UnitOfMeasure}
                      getOptionLabel={(option) => `${option.name}`}
                      getOptionValue={(option) => `${option._id}`}
                      value={weightUnitOfMeasure}
                      styles={customStyles}
                      onChange={handleSelectWeightUnit}
                      placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.UOM')}
                      isClearable
                      className="common-select"
                      classNamePrefix="common-select"
                    />
                    {errors.weightUnitOfMeasure && <span className="error-message">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.UOM_REQUIRED')} </span>}
                  </div>
                </FormGroup>
              </Col>

              <Col className="add-form">
                <FormGroup className={highlightedKeys?.includes('pricePerUnit') ? highlightedFieldClass : 'd-flex'}>
                  <div className="highlight-form mb-0 common-input-control flex-fill">
                    <p className="field-name text-bold">
                      {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.PRICE_PER_UNIT')}
                      <span className="asterisk asterisk-req-green ">*</span>
                    </p>

                    <input
                      type="text"
                      name="pricePerUnit"
                      {...register('pricePerUnit', {
                        required: false,
                        pattern: {
                          value: /^[0-9]+(\.[0-9]+)?$/,
                          message: t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.INVALID_NUMBER'),
                        },
                      })}
                      placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.PRICE_PER_UNIT')}
                      className="form-control"
                      onKeyPress={(e) => {
                        const charCode = e.which ? e.which : e.keyCode;
                        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className="size-uom mb-0 common-react-select">
                    <p className="field-name text-bold">&nbsp;</p>
                    <Select
                      {...register('pricePerUnitCurrency', {
                        required: false,
                      })}
                      name="pricePerUnitCurrency"
                      options={currencyOptions}
                      getOptionLabel={(option) => `${option.label}`}
                      getOptionValue={(option) => `${option.value}`}
                      value={pricePerUnitCurrency}
                      styles={customStyles}
                      onChange={handleSelectPricePerUnitCurrency}
                      placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.CURRENCY')}
                      isClearable
                      className="common-select"
                      classNamePrefix="common-select"
                    />
                  </div>
                </FormGroup>
              </Col>

              <Col className="add-form">
                <FormGroup className={highlightedKeys?.includes('quantity') ? highlightedFieldClass : 'd-flex'}>
                  <div className="highlight-form  mb-0 common-input-control flex-fill">
                    <p className="field-name text-bold">
                      {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.QUANTITY')}
                      <span className="asterisk asterisk-req-green">*</span>
                    </p>
                    <input
                      type="text"
                      label="Quantity"
                      name="quantity"
                      {...register('quantity', { required: false })}
                      placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ENTER_QUANTITY')}
                      className="form-control"
                    />
                  </div>
                  <div className="size-uom mb-0 common-react-select">
                    <p className="field-name text-bold">&nbsp;</p>
                    <Select
                      {...register('quantityUnitOfMeasure', {
                        required: false,
                      })}
                      name="quantityUnitOfMeasure"
                      options={UnitOfMeasure}
                      getOptionLabel={(option) => `${option.name}`}
                      getOptionValue={(option) => `${option._id}`}
                      value={quantityUnitOfMeasure}
                      styles={customStyles}
                      onChange={handleSelectQuantityUnit}
                      placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.UOMS')}
                      isClearable
                      className="common-select"
                      classNamePrefix="common-select"
                    />
                  </div>
                  {errors.quantityUnitOfMeasure && <span className="error-message">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.UOM_REQUIRED')} </span>}
                </FormGroup>
              </Col>
              <Col className="add-form">
                <FormGroup className="w-100">
                  <div
                    className={
                      highlightedKeys?.includes('finished')
                        ? `${highlightedFieldCustomReactSelect} common-react-select`
                        : `${customReactSelect} common-react-select`
                    }
                  >
                    <p className="field-name text-bold">
                      {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.FINISH')}
                      <span className="asterisk asterisk-req-green">*</span>
                    </p>

                    <Select
                      {...register('finished', {
                        required: false,
                      })}
                      name="finished"
                      options={finalList}
                      getOptionLabel={(option) => `${option.name}`}
                      getOptionValue={(option) => `${option._id}`}
                      value={final}
                      styles={customStyles}
                      onChange={handleSelectFinals}
                      placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_FINISH')}
                      isClearable
                      className="common-select"
                      classNamePrefix="common-select"
                    />
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </Col>
          {compositions()}
          <Col md={2} className="add-form">
            <FormGroup className="w-100">
              <div
                className={
                  highlightedKeys?.includes('newPlacement')
                    ? `${highlightedFieldCustomReactSelect} common-react-select`
                    : `${customReactSelect} common-react-select`
                }
              >
                <p className="field-name text-bold">
                  {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.PLACEMENT')}
                  <span className="asterisk asterisk-req-green">*</span>
                </p>
                <MultiSelect
                  name="newPlacement"
                  options={placementOptions}
                  className="product-custom-multiselect common-new-multiselect"
                  value={placementValue}
                  labelledBy={t('POMS.GRADING_GROUP.TOP_GROUP_BAR.BRAND_NOT_SELECTED')}
                  onChange={(selected) => handleSelectPlacement(selected)}
                />
              </div>
            </FormGroup>
          </Col>
          {customAttributeBomList
            ?.filter((ele) => ele?.bomTypeID === BOMProperty?._id)
            ?.map((ele) => {
              const selectedItem = clonedBomData?.dynamicColumn?.find((eleDyna) => {
                return eleDyna?.colId ? eleDyna?.colId?._id === ele?._id : eleDyna?._id === ele?._id;
              });
              if (ele.type === 'dropdown' && ele.isActive) {
                return (
                  <Col md={2} className="add-form" key={ele?._id}>
                    <div
                      className={
                        highlightedKeys?.includes(`dynamicColumn_${ele?._id}`)
                          ? `${highlightedFieldCustomReactSelect} common-react-select`
                          : `${customReactSelect} common-react-select`
                      }
                    >
                      <p className="field-name">{ele?.keyName}</p>
                      <Select
                        name="customValue"
                        options={ele?.options?.filter((option) => option?.isActive)}
                        value={ele?.options
                          ?.filter((option) => option?.isActive)
                          ?.find((option) => (selectedItem?.valueId ? selectedItem?.valueId?._id === option?._id : option._id === selectedItem?.optionsValue))}
                        onChange={(e) => handleSelectDynamic(e, 'optionsValue', ele?._id)}
                        getOptionLabel={(option) => option?.keyName}
                        getOptionValue={(option) => option?._id}
                        className="common-select"
                        classNamePrefix="common-select"
                        isClearable
                        placeholder="Select..."
                      />
                    </div>
                  </Col>
                );
              }
            })}
          {customAttributeBomList
            ?.filter((ele) => ele?.bomTypeID === BOMProperty?._id)
            ?.map((ele) => {
              const idText = ele;
              const maxlen = ele.textFieldConfig?.charLimit;
              const isExceedable = ele.textFieldConfig?.isExceedable;
              const isHightlight = ele.textFieldConfig?.isHighlightable;
              const shouldHighlight = isExceedable && isHightlight && ele?.valueText?.length > ele.textFieldConfig?.charLimit;

              const selectedItem = clonedBomData?.dynamicColumn?.find((eleDyna) => {
                return eleDyna?.colId ? eleDyna?.colId?._id === ele?._id : eleDyna?._id === ele?._id;
              });
              if (ele.type === 'text' && ele.isActive) {
                return [
                  <Col key={idText} md="2">
                    <div
                      className={highlightedKeys?.includes(`dynamicColumn_${ele?._id}`) ? `${highlightedField} common-input-control` : 'common-input-control'}
                    >
                      <p className="field-name">{ele.keyName}</p>
                      <input
                        maxLength={maxlen}
                        style={shouldHighlight ? { color: 'red' } : {}}
                        type="text"
                        value={selectedItem ? selectedItem?.valueText : ''}
                        onChange={(e) => handleSelectDynamic(e.target.value, 'valueText', ele?._id)}
                        className="form-control"
                      />
                    </div>
                  </Col>,
                ];
              }
              return [];
            })}
          {customAttributeBomList
            ?.filter((ele) => ele?.bomTypeID === BOMProperty?._id)
            ?.map((ele) => {
              const selectedItem = clonedBomData?.dynamicColumn?.find((eleDyna) =>
                eleDyna?.colId ? eleDyna?.colId?._id === ele?._id : eleDyna?._id === ele?._id,
              );

              if (ele.type === 'Multi Dropdown' && ele.isActive) {
                return (
                  <Col md="2" key={ele?._id}>
                    <div
                      className={
                        highlightedKeys?.includes(`dynamicColumn_${ele?._id}`)
                          ? `${highlightedFieldCustomReactSelect} common-react-select`
                          : `${customReactSelect} common-react-select`
                      }
                    >
                      <p className="field-name">{ele?.keyName}</p>
                      <MultiSelect
                        options={ele?.options
                          ?.filter((opt) => opt?.isActive)
                          .map((opt) => ({
                            label: opt.keyName,
                            value: opt._id,
                          }))}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={(() => {
                          if (Array.isArray(selectedItem?.optionsValue)) {
                            return selectedItem.optionsValue.map((opt) => ({
                              label: opt.label || opt.keyName || '',
                              value: opt.value || opt._id || '',
                            }));
                          }
                          if (Array.isArray(selectedItem?.valueId)) {
                            return selectedItem.valueId.map((opt) => ({
                              label: opt.label || opt.keyName || '',
                              value: opt.value || opt._id || '',
                            }));
                          }
                          return [];
                        })()}
                        onChange={(selected) => handleSelectDynamic(selected, 'optionsValue', ele?._id)}
                        labelledBy={ele?.keyName}
                        hasSelectAll
                        overrideStrings={{ selectSomeItems: 'Select...', allItemsAreSelected: 'All Selected' }}
                      />
                    </div>
                  </Col>
                );
              }
              return null;
            })}
        </div>

        <div className="collapse-card add-bom-accordion">
          <Accordion activeKey="0">
            <Card className="bom-add-card">
              <Card.Header>
                <span className="bom-subheader text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ADDITIONAL_INFO')}</span>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body className="common-border-top p-0">
                  <textarea
                    name="additionalInfo"
                    rows="12"
                    placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ADDITIONAL_INFO')}
                    className="form-control bom-addinfo-textarea text-black"
                    maxLength={ADDITIONAL_INFO_MAX_LENGTH}
                    {...register('additionalInfo', {
                      required: false,
                    })}
                  />
                  <div className="text-right pr-2 pb-2">
                    <span className="text-success">
                      {watch('additionalInfo')?.length || 0}/{ADDITIONAL_INFO_MAX_LENGTH}
                    </span>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>

        <div className="collapse-card add-bom-accordion mt-3">
          <Accordion activeKey={subBomActiveKey}>
            <Card className="bom-add-card">
              <Card.Header>
                <div className="custom-control pl-0 d-flex align-items-center design-switch">
                  <input
                    type="checkbox"
                    className="form-check-input mt-0"
                    id="subBOMSwitch"
                    name="subBOMSwitch"
                    checked={isSubBOMSwitch}
                    onChange={(e) => {
                      onSwitchChange(e);
                    }}
                  />
                  <label className="switch-text  mb-0 ml-16 f-16 text-bold" htmlFor="subBOMSwitch">
                    {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SUB_BOM')}
                  </label>
                </div>

                <Accordion.Toggle
                  className="btn-toggle accordion-toggle-icon"
                  as={Button}
                  disabled={!isSubBOMSwitch}
                  variant="link"
                  onClick={handleOpenSubBomAccordion}
                >
                  <CustomToggle eventKey="0" />
                </Accordion.Toggle>
              </Card.Header>
              {isSubBOMSwitch && (
                <Accordion.Collapse className="edit-collapse" eventKey="0">
                  {bomDocumentState?.loading ? (
                    <div className="text-center">
                      <Loader />
                    </div>
                  ) : (
                    <Card.Body className="accordion-new-body">
                      <div className="table-responsive">
                        <Table className="table custom-table sub-bom-table  layout-fixed font-13" bordered>
                          <thead>
                            <tr>
                              <th className="w-50px" />
                              <th className="w-120px text-left">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.IMAGE')}</th>
                              <th className="w-150px last-fix-col"> {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_CODE')}</th>
                              <th className="w-200px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_DESCRIPTION')}</th>
                              <th className="w-150px">
                                <p className="field-lbl mb-0  asterisk-req-green">
                                  {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUPLIER')}
                                  <span>*</span>
                                </p>
                              </th>
                              <th className="w-150px">
                                {' '}
                                <p className="field-lbl mb-0  asterisk-req-green">
                                  {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_TYPE')}
                                  <span>*</span>
                                </p>
                              </th>
                              <th className="w-150px">
                                <p className="field-lbl mb-0 asterisk-req-green">
                                  {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUB_TYPE')}
                                  <span>*</span>
                                </p>
                              </th>
                              <th className="w-200px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SIZE/UOM')}</th>
                              <th className="w-200px">
                                <p className="field-lbl mb-0 asterisk-req-green">
                                  {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.WEIGHT/UOM')}
                                  <span>*</span>
                                </p>
                              </th>
                              <th className="w-200px">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.QUANTITY/UOM')}</th>
                              <th className="w-120px">
                                <p className="field-lbl mb-0 asterisk-req-green">
                                  {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.FINISH')}
                                  <span>*</span>
                                </p>
                              </th>
                              {columnHeader?.map((header, index) => (
                                <th key={index} className="w-200px">
                                  <div className="d-inline-flex align-items-center">
                                    <p className="field-lbl mb-0 asterisk-req-green ">
                                      {t(header)}
                                      <span>*</span>
                                    </p>
                                    {index === columnHeader.length - 1 && (
                                      <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                                        <button
                                          className="btn ml-2 add-btn-subbom"
                                          onClick={toogleAddComposition}
                                          type="button"
                                          aria-label={t('DEVLOPMENT_ORDER.BOM.BOM_LISTS.ADD')}
                                        >
                                          <i className="icon-Add f-20" />
                                        </button>
                                      </CustomTooltip>
                                    )}

                                    {columnHeader?.length > 1 && (
                                      <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.DELETE')}>
                                        <button
                                          className="btn ml-2 add-btn-subbom"
                                          type="button"
                                          aria-label={t('DEVLOPMENT_ORDER.BOM.BOM_LISTS.ADD')}
                                          onClick={(e) => toogleDeleteComposition(e, index)}
                                        >
                                          {' '}
                                          <i className="icon-Delete f-20" />
                                        </button>
                                      </CustomTooltip>
                                    )}
                                  </div>
                                </th>
                              ))}
                              <th className="w-80px" />
                            </tr>
                          </thead>
                          {bomDocumentState?.cardList.map((data, index) => (
                            <BomSubType
                              key={data?._id}
                              dataValue={data}
                              dataIndex={index}
                              bomDocumentState={bomDocumentState}
                              setBomDocumentState={setBomDocumentState}
                              setCoumnHeader={setCoumnHeader}
                              columnHeader={columnHeader}
                              id={id}
                              setBomDeletedData={setBomDeletedData}
                              compositionErrors={compositionErrors}
                              setCompositionErrors={setCompositionErrors}
                              BOMId={BOMId}
                              devOrderId={devOrderId}
                            />
                          ))}
                        </Table>
                      </div>
                    </Card.Body>
                  )}
                </Accordion.Collapse>
              )}
            </Card>
          </Accordion>
        </div>

        <div className="collapse-card add-bom-accordion mt-3">
          <Accordion activeKey={activeKey}>
            <Card className="bom-add-card">
              <Card.Header>
                <div className="common-checkbox">
                  <input
                    type="checkbox"
                    id="diffCompSupps"
                    name="diffCompSupps"
                    disabled={isFromLibrary || (!isFromLibrary && suppliers?.length === 1)}
                    onChange={(e) => ForCompSupps(e)}
                    checked={showNewTable}
                  />
                  <label htmlFor="diffCompSupps" className="chklabel">
                    <span className="bom-subheader text-bold f-16">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.MULTIPLE_SUPLIERS')}</span>
                  </label>
                </div>
                <Accordion.Toggle
                  className="btn-toggle accordion-toggle-icon "
                  as={Button}
                  disabled={!showNewTable}
                  variant="link"
                  onClick={handleOpenAccordion}
                >
                  <CustomToggle eventKey="0" />
                </Accordion.Toggle>
              </Card.Header>
              {showNewTable && (
                <Accordion.Collapse className="edit-collapse" eventKey="0">
                  <Card.Body>{newTable()}</Card.Body>
                </Accordion.Collapse>
              )}
            </Card>
          </Accordion>
        </div>
        {dppAddEditAccess && (
          <div className="collapse-card add-bom-accordion">
            <Accordion>
              <Card className="bom-add-card">
                <Card.Header>
                  <span className="bom-subheader text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.BOM_PRODUCT_IMPACT')}</span>
                  <Accordion.Toggle className="btn-toggle accordion-toggle-icon " as={Button} variant="link" eventKey="0">
                    <CustomToggle eventKey="0" />
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body className="common-border-top">
                    <BomProductImpact
                      combinedDataArray={combinedDataArray}
                      id={id}
                      isCombinationSupplierActive={showNewTable}
                      BomSuppliers={BomSuppliers}
                      ref={bomProductImpact}
                      isFromLibrary={isFromLibrary}
                      bomDetailsBasedOnId={bomDetailsBasedOnId}
                      referenceSupp={componentSupplierOptions}
                      bomSubType={bomSubType}
                      bomTypeId={BOMProperty?._id}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </div>
        )}
        <div className="collapse-card add-bom-accordion">
          <Accordion>
            <Card className="bom-add-card">
              <Card.Header>
                <span className="bom-subheader text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.CATEGORIES')}</span>
                <Accordion.Toggle className="btn-toggle accordion-toggle-icon " as={Button} variant="link" eventKey="0">
                  <CustomToggle eventKey="0" />
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse className="edit-collapse" eventKey="0">
                <Card.Body>
                  <Row className="bom-types-row">
                    <Col className="add-form">
                      <FormGroup className="mb-0">
                        <div className="custom-react-select mb-0 common-react-select">
                          <label className="field-lbl bom-form-title bom-select-form asterisk-req"> {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.BRAND')}</label>
                          <Select
                            {...register('brand', { required: false })}
                            name="brand"
                            menuPosition="fixed"
                            menuShouldBlockScroll
                            menuShouldScrollIntoView
                            options={brandList}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option._id}`}
                            value={brand}
                            styles={customStyles}
                            onChange={handleBrand}
                            placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_BRAND')}
                            isClearable
                            className="common-select"
                            classNamePrefix="common-select"
                          />
                        </div>
                      </FormGroup>
                    </Col>
                    {subBrandAccess && (
                      <Col className="add-form">
                        <FormGroup className="mb-0">
                          <div className="custom-react-select mb-0 common-react-select">
                            <label className="field-lbl bom-form-title bom-select-form asterisk-req"> {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SUB_BRAND')}</label>
                            <Select
                              {...register('subBrand', { required: false })}
                              name="subBrand"
                              menuPosition="fixed"
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              options={subBrandOption?.filter((val) => val?.isActive)}
                              getOptionLabel={(option) => `${option.name}`}
                              getOptionValue={(option) => `${option._id}`}
                              value={subBrand}
                              styles={customStyles}
                              onChange={handleSubBrand}
                              placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_SUB_BRAND')}
                              isClearable
                              className="common-select"
                              classNamePrefix="common-select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                    {catBasedOnPTData && (
                      <Col className="add-form">
                        <FormGroup className="mb-0">
                          <div className="custom-react-select mb-0 common-react-select">
                            <label className="field-lbl bom-form-title bom-select-form asterisk-req">
                              {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.PRODUCT_TYPE')}
                            </label>
                            <Select
                              name="productType"
                              menuPosition="fixed"
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              options={pcTypeList}
                              value={selectedProductType}
                              onChange={handleSelectProductType}
                              getOptionLabel={(option) => option?.name}
                              getOptionValue={(option) => option?._id}
                              className="common-select"
                              classNamePrefix="common-select"
                              placeholder={
                                t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SELECT') + t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.PRODUCT_TYPE')
                              }
                              isClearable
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}
                    <Col className="add-form">
                      <FormGroup className="mb-0">
                        <div className="custom-react-select mb-0 common-react-select">
                          <label className="field-lbl bom-form-title bom-select-form asterisk-req">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.CATEGO0RY_1')}</label>
                          <Select
                            {...register('category1', {
                              required: false,
                            })}
                            name="category1"
                            menuPosition="fixed"
                            menuShouldBlockScroll
                            menuShouldScrollIntoView
                            options={catBasedOnPTData ? category1Derived : category1List}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option._id}`}
                            value={category1}
                            styles={customStyles}
                            onChange={handleCategory1}
                            placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_CATEGORY_1')}
                            isClearable
                            className="common-select"
                            classNamePrefix="common-select"
                          />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col className="add-form">
                      <FormGroup className="mb-0">
                        <div className="custom-react-select mb-0 common-react-select">
                          <label className="field-lbl bom-form-title bom-select-form asterisk-req">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.CATEGORIES_2')}</label>
                          <Select
                            {...register('category2', {
                              required: false,
                            })}
                            name="category2"
                            menuPosition="fixed"
                            menuShouldBlockScroll
                            menuShouldScrollIntoView
                            options={catBasedOnPTData ? category2Derived : category2List}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option._id}`}
                            value={category2}
                            styles={customStyles}
                            onChange={handleCategory2}
                            placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_CATEGORY2')}
                            isClearable
                            className="common-select"
                            classNamePrefix="common-select"
                          />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col className="add-form">
                      <FormGroup className="mb-0">
                        <div className="custom-react-select mb-0 common-react-select">
                          <label className="field-lbl bom-form-title bom-select-form asterisk-req">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.CATEGORIES_3')}</label>
                          <Select
                            {...register('category3', {
                              required: false,
                            })}
                            name="category3"
                            menuPosition="fixed"
                            menuShouldBlockScroll
                            menuShouldScrollIntoView
                            options={catBasedOnPTData ? category3Derived : category3List}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option._id}`}
                            value={category3}
                            styles={customStyles}
                            onChange={handleCategory3}
                            isDisabled={!(category1 && category2)}
                            placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_CATEGORY3')}
                            isClearable
                            className="common-select"
                            classNamePrefix="common-select"
                          />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col className="add-form">
                      <FormGroup className="mb-0">
                        <div className="custom-react-select mb-0 common-react-select">
                          <label htmlFor="category4" className="field-lbl bom-form-title bom-select-form asterisk-req">
                            {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.CATEGORIES_4')}
                          </label>
                          <Select
                            {...register('category4', {
                              required: false,
                            })}
                            name="category4"
                            menuPosition="fixed"
                            menuShouldBlockScroll
                            menuShouldScrollIntoView
                            options={catBasedOnPTData ? category4Derived : category4List}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option._id}`}
                            value={category4}
                            styles={customStyles}
                            onChange={handleCategory4}
                            isDisabled={!(category1 && category2 && category3)}
                            placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SELECT_CATEGORY_4')}
                            isClearable
                            className="common-select"
                            classNamePrefix="common-select"
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
        <div className="collapse-card add-bom-accordion">
          <Accordion>
            <Card className="bom-add-card">
              <Card.Header>
                <span className="bom-subheader text-bold">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SUPPORTING_DOCUMENT')}</span>
                <Accordion.Toggle className="btn-toggle accordion-toggle-icon " as={Button} variant="link" eventKey="0">
                  <CustomToggle eventKey="0" />
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse className="edit-collapse" eventKey="0">
                <Card.Body className="support-card-body">
                  <Row>
                    <Col md={12}>
                      {renderSuppotingDoc &&
                        handleRenderSupportingDoc({
                          devOrderId,
                          bomType: BOMProperty._id,
                        })}
                    </Col>
                  </Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
        {editState.mode && colorWay?.list?.length > 0 && Array.isArray(colorWay?.list) && colorWay?.list?.[0]?._id && (
          <div className="bom-lib-search-color">
            <SearchBar onSearch={(e) => handleColourwaySeacrh(e.target.value)} value={searchText} placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.SEARCH')} />
          </div>
        )}

        <BomColourwaysComponent
          libId={libId}
          BomSuppliers={BomSuppliers}
          combinedDataArray={combinedDataArray}
          ref={bomColourRef}
          editState={editState}
          isFromLibrary={isFromLibrary}
          searchText={searchText}
          showCombinationArray={showNewTable}
          setRemoveLibId={setRemoveLibId}
          placementList={placementValue}
        />

        {!isEmpty(searchText) && isEmpty(filteredPermit) && <span className="error-message">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.RECORD_NOT_SAVED')}</span>}
      </div>
    );
  };

  const compositions = () => {
    return (
      Array.isArray(customBom?.composition) &&
      !isEmpty(customBom?.composition) &&
      customBom.composition.map((element, i) => {
        return (
          <div key={element} className="col-lg-4 add-form">
            {/* <Col key={element} className="add-form"> */}
            <div className="d-flex align-items-start">
              <Col md={4} className="pl-0">
                <FormGroup className={highlightedKeys?.includes('composition') ? 'add-common-form highlighted-field' : 'add-common-form'}>
                  <div className="highlight-form mb-0 common-input-control">
                    <p className="field-name text-bold">
                      {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.PERCENTAGE')}
                      <span className="asterisk asterisk-req-green">*</span>
                    </p>

                    <input
                      type="number"
                      name="percentage"
                      value={element.percentage ? element.percentage : ''}
                      onChange={(event) => {
                        handleChangeComposition(event, i, 'percentage');
                      }}
                      placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.PERCENTAGE')}
                      className="form-control"
                    />
                    {showPercentageError && !element?.percentage && (
                      <span className="error-message">{t('BOM_TYPE_GROUP_VIEW.VALIDATION_ERROR.PERCENTAGE_FOR_COMPOSITION')}</span>
                    )}
                    {showPercentageValueError && i === lastIndex && (
                      <span className="error-message">{t('BOM_TYPE_GROUP_VIEW.VALIDATION_ERROR.TOTAL_PERCENTAGE_VALIDATION')}</span>
                    )}
                    {error && !element?.composition && !element?.percentage && (
                      <span className="error-message">{t('BOM_TYPE_GROUP_VIEW.VALIDATION_ERROR.PERCENTAGE_IS_REQUIRED')} </span>
                    )}
                  </div>
                </FormGroup>
              </Col>
              <div className="highlight-form common-react-select flex-fill">
                <div className={highlightedKeys?.includes('bomComponentSubType') ? highlightedFieldCustomReactSelect : customReactSelect}>
                  <p className="field-name text-bold">
                    {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION')}
                    <span className="asterisk asterisk-req-green">*</span>
                  </p>

                  <Select
                    name="composition"
                    options={[{ _id: 'addNew', name: 'Add New Composition' }, ...Composition]}
                    key={i}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    value={element.composition}
                    styles={customStyles}
                    onChange={(event) => handleChangeComposition(event, i, 'composition')}
                    placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPOSITION')}
                    isClearable
                    menuPosition="fixed"
                    className="common-select"
                    classNamePrefix="common-select"
                  />
                </div>
                {showPercentageError && !element?.composition && (
                  <span className="error-message">{t('BOM_TYPE_GROUP_VIEW.VALIDATION_ERROR.COMPOSITION_FOR_PERCENTAGE')}</span>
                )}
                {error && !element?.composition && !element?.percentage && (
                  <span className="error-message">{t('BOM_TYPE_GROUP_VIEW.VALIDATION_ERROR.COMPOSITION_IS_REQUIRED')}</span>
                )}

                {customBom.composition.length === i + 1 && (
                  <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                    <button
                      onClick={(e) => {
                        handleAddRow(e);
                      }}
                      className="btn btn-outline add-comp-btn btn-absolute"
                      type="button"
                      aria-label="add"
                      style={{ right: '-5px' }}
                    >
                      <i className="icon-Add" />
                    </button>
                  </CustomTooltip>
                )}
                {i !== 0 && (
                  <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.DELETE')}>
                    <button
                      onClick={(e) => {
                        handleRemoveClick(e, i);
                      }}
                      className="btn  btn-outline delete-comp-btn btn-absolute"
                      type="button"
                      aria-label="delete"
                    >
                      <i className="icon-Delete" />
                    </button>
                  </CustomTooltip>
                )}
              </div>
            </div>
          </div>
        );
      })
    );
  };
  const newTable = () => {
    return (
      showNewTable &&
      combinedDataArray &&
      !isEmpty(combinedDataArray) &&
      combinedDataArray.map((ele, i) => {
        return (
          <Row className="multiple-supplier-row mb-16" key={i}>
            <Col className="add-form" md={5}>
              <div className="common-react-select mb-0">
                <label className="field-lbl bom-select-form bom-form-title asterisk-req-green">
                  {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.PRODUCT_SUPPLIER')}
                  <span>*</span>
                </label>{' '}
                <Select
                  name="product Supplier"
                  maxMenuHeight={132}
                  menuPosition="fixed"
                  menuShouldBlockScroll
                  menuShouldScrollIntoView
                  options={devOrderId ? suppliers : componentSupplierOptions}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option._id}`}
                  value={ele?.productSupplier}
                  styles={customReactSelect}
                  onChange={(e) => handleProdSupplier(e, i)}
                  placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.PRODUCT_SUPPLIER')}
                  className="common-select"
                  classNamePrefix="common-select"
                />
              </div>
              {showRequirmentError && inSubmit && ele.productSupplier === null && <span className="error-message">Product Supplier is required</span>}
            </Col>
            <Col className="add-form" md={7}>
              <div className="d-flex">
                <div className="flex-fill mb-0 common-react-select">
                  <label className="field-lbl bom-select-form bom-form-title asterisk-req-green">
                    {t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUPLIER')}
                    <span>*</span>
                  </label>
                  <Select
                    name="Component Supplier"
                    maxMenuHeight={132}
                    menuPosition="fixed"
                    menuShouldBlockScroll
                    menuShouldScrollIntoView
                    options={componentSupplierOptions}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option._id}`}
                    value={ele?.componentSupplier}
                    styles={customReactSelect}
                    onChange={(e) => handleCompSupplier(e, i)}
                    placeholder={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENET_SUPPLIER')}
                    className="common-select"
                    classNamePrefix="common-select"
                  />
                  {showRequirmentError && inSubmit && ele.componentSupplier === null && <span className="error-message">Component Supplier is required</span>}
                </div>
                <div style={{ marginLeft: '50px' }} className="d-flex align-items-end justify-content-start">
                  <CustomTooltip placement="top" tooltipText={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ADD')}>
                    <button aria-label="add" type="button" className="btn mr-3 line-normal save-bom-configure" onClick={addCombinedArray}>
                      <i className="icon-Add f-24" />
                    </button>
                  </CustomTooltip>
                  <CustomTooltip placement="top" tooltipText={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.DELETE')}>
                    <button aria-label="delete" className="btn line-normal save-bom-configure " type="button" onClick={(e) => deleteCombinedArray(e, i)}>
                      <i className="icon-Delete f-24" />
                    </button>
                  </CustomTooltip>
                </div>
              </div>
            </Col>
          </Row>
        );
      })
    );
  };

  const ForCompSupps = (e) => {
    e.preventDefault();
    if (showNewTable) {
      setShowCombinationArray(true);
    } else {
      setShowRemoveCombinationArray(true);
    }
  };

  const onConfirmedShowNewTable = () => {
    setCombinedDataArray([{ componentSupplier: null, productSupplier: null }]);
    selectBomSuppliers([]);
    setUpSupplier([]);
    setShowNewTable(false);
    setShowCombinationArray(false);
  };

  const toggleConfirmation = () => {
    setShowCombinationArray(!showCombinationArray);
    setShowNewTable(false);
  };

  const onConfirmRemoveNewTable = () => {
    setShowRemoveCombinationArray(false);
    selectBomSuppliers([]);
    setUpSupplier([]);
    setShowNewTable(true);
    setValue('BOMSupplier', []);
    register('BOMSupplier', []);
  };

  const handleColourwaySeacrh = async (value) => {
    setSearchText(value);
    const filterColourWyas = await bomColourRef?.current?.filterColourways(value);
    setFilteredPermit(filterColourWyas);
  };

  const otherData = () => {
    return <div>{forTop()}</div>;
  };

  const srcForImage = () => {
    return !isEmpty(ImageState.data) ? ImageState.data : '';
  };

  const handleImageModalOpen = () => {
    setShowUploadModal(true);
  };

  const onClose = async () => {
    if (!isEmpty(finalDocuments)) {
      const supportingDocIds = Array.isArray(finalDocuments) && finalDocuments.filter((item) => !item?.isSaved).map((item) => item?._id);
      if (!isEmpty(supportingDocIds)) {
        const params = { ids: supportingDocIds };
        await dispatch(supportingAction.deleteSupportingDocuments(params, '', 1));
      }
    }
    setEmptyDocs(true);
    setFinalDocuments([]);
    toggle();
    setIsAddEditClick(false);
  };

  const bomImageDropzoneRef = useRef();

  /**
   * Called by BomImageDropzone (Library only) when the user confirms or closes the upload modal.
   * A confirmed image is kept as a base64 upload, so any earlier asset-library selection is cleared.
   * @param {string} [type] - 'close' when the modal is dismissed without uploading.
   * @returns {Promise<void>}
   */
  const handleLibraryImageUpload = async (type) => {
    if (type !== 'close') {
      const { imageRes, originalImg } = (await bomImageDropzoneRef.current?.showCroppedImg()) || {};
      if (imageRes?.length) {
        setCroppedImage(imageRes);
        setOriginalImage(originalImg || imageRes);
        setSelectedAssetKey(null);
        setSelectedAssetId(null);
        setIsUploadAsset(false);
        setSendToAssetLibrary(false);
        setIsNewUploaded(true);
        setRemoveImage(false);
      }
    }
    setShowUploadModal(false);
  };

  return (
    <>
      <div className="add-edit-bom page-title-filter sticky">
        <div className="d-flex justify-content-between align-items-center w-100">
          <span className="add-bom-title" id="contained-modal-title-vcenter">
            {title}
          </span>
          <div className="action-icons-container">
            <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.SAVE')}>
              <button onClick={handleSubmit(onSubmitMethod)} type="submit" aria-label="save" className="btn" disabled={showLoader}>
                <i className="icon-Save-1 f-28" />
              </button>
            </CustomTooltip>
            <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.CLOSE')}>
              <button aria-label="close" type="button" onClick={onClose} className="btn" disabled={showLoader}>
                <i className="icon-close f-20" />
              </button>
            </CustomTooltip>

            <>
              <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.UPLOAD')}>
                <button aria-label="upload" className="btn" type="button" onClick={() => handleImageModalOpen()}>
                  <i className="icon-Upload-1 f-28" aria-hidden="true" />
                </button>
              </CustomTooltip>

              {id && (
                <CustomTooltip placement="top" tooltipText={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.REMOVE_IMAGE')}>
                  <button
                    className={croppedImage === noImage ? 'btn disabled p-0' : 'btn'}
                    type="button"
                    aria-label="delete"
                    onClick={() => setShowImageRemoveConfirmationPopup(true)}
                  >
                    <i className="icon-Delete f-28" aria-hidden="true" />
                  </button>
                </CustomTooltip>
              )}

              <div className="ml-2">
                <img width="47" className="header-bom-image" alt="croppedImage" src={croppedImage} />
              </div>
            </>
          </div>
        </div>
      </div>
      <Container fluid className="bom-page-modal">
        <form className="bom-form-container" autoComplete="off">
          {showLoader || bomApiLoder ? <Loader /> : otherData()}
        </form>
      </Container>

      {isFromLibrary ? (
        showUploadModal && (
          <Modal className="common-custom-modal modal-medium-3x" size="lg" show={showUploadModal} backdrop="static" centered>
            <Modal.Header>
              <div className="d-flex justify-content-center align-items-center w-100">
                <Modal.Title className="expand-modal-title ml-auto">
                  <span className="common-title">{t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.UPLOAD_IMAGE')}</span>
                </Modal.Title>
                <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.CLOSE')}>
                  <button aria-label="close" type="button" className="btn p-0 ml-auto" onClick={() => handleLibraryImageUpload('close')}>
                    <i className="icon-close common-close-icon cursor-pointer" />
                  </button>
                </CustomTooltip>
              </div>
            </Modal.Header>
            <Modal.Body>
              <BomImageDropzone
                ref={bomImageDropzoneRef}
                title=""
                onSubmit={handleLibraryImageUpload}
                image={srcForImage()}
                isEditMode={!isNewUploaded}
                acceptedFileExtenstion=".jpeg,.jpg,.png"
              />
            </Modal.Body>
          </Modal>
        )
      ) : (
        <ImageUploadModal
          show={showUploadModal}
          fetchImages={(search, page, limit, allowedImageExtensions) =>
            getImagesByLocation('Bill of Materials', devOrderId, search, allowedImageExtensions, page, limit)
          }
          allowedImageExtensions={IMAGE_PICKER_EXTENSIONS}
          showAddToAssetLibrary
          existingImage={croppedImage !== noImage ? croppedImage : null}
          onClose={() => setShowUploadModal(false)}
          onSave={handleBomImageSave}
        />
      )}

      {showImageRemoveConfirmationPopup && (
        <DeletePopup
          onOpen={showImageRemoveConfirmationPopup}
          onConfirm={removeImg}
          title={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.REMOVE_IMAGE')}
          message={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.REMOVE_MESSAGE')}
          toggle={() => setShowImageRemoveConfirmationPopup(!showImageRemoveConfirmationPopup)}
        />
      )}

      {showCombinationArray && (
        <DeletePopup
          onOpen={showCombinationArray}
          onConfirm={onConfirmedShowNewTable}
          title={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUPLIERS')}
          message={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_MESSAGE')}
          toggle={toggleConfirmation}
        />
      )}

      {showRemoveCombinationArray && (
        <DeletePopup
          onOpen={showRemoveCombinationArray}
          onConfirm={onConfirmRemoveNewTable}
          title={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUPLIERS')}
          message={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_MESSAGE')}
          toggle={() => setShowRemoveCombinationArray(!showRemoveCombinationArray)}
        />
      )}

      {showComponentTypePopup && (
        <SetComponentType
          onOpen={showComponentTypePopup}
          onSubmit={(data) => {
            saveComponentType(data);
          }}
          title={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ADD_BOM_SUB_TYPE')}
          bomTypeId={BOMId}
          BOMSubTypesList={ReferenceType}
          loggedInUserId={loggedInUserId}
          loading={showSubTypeLoader}
          toggle={() => setShowComponentTypePopup(!showComponentTypePopup)}
          label={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_TYPE')}
        />
      )}
      {showComponentSubTypePopup && (
        <SetComponentType
          onOpen={showComponentSubTypePopup}
          onSubmit={(data) => {
            saveComponentSubType(data);
          }}
          title={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ADD_COMPONENT_BOM_SUB_TYPE')}
          bomTypeId={BOMId}
          BOMSubTypesList={ReferenceType}
          loggedInUserId={loggedInUserId}
          loading={showSubTypeLoader}
          toggle={() => setShowComponentSubTypePopup(!showComponentSubTypePopup)}
          label={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.COMPONENT_SUB_TYPE')}
        />
      )}
      {showCompositionModal && (
        <SetComponentType
          onOpen={showCompositionModal}
          onSubmit={(data) => {
            saveCompositionType(data);
          }}
          title={t('BOM_LIBRARY.ADD_EDIT_BOM_LIBRARY.ADD_COMPOSITION')}
          bomTypeId={BOMId}
          BOMSubTypesList={ReferenceType}
          loggedInUserId={loggedInUserId}
          loading={showSubTypeLoader}
          toggle={() => setShowCompositionModal(!showCompositionModal)}
          forComposition
        />
      )}
    </>
  );
}

export default AddEditBomLibrary;
